
function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2c70"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2c70"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
var $2e72581c38d9945a$exports = {};
$parcel$extendImportMap({
    "5zyUS": "jh-logo-80.1659c531.png",
    "9As52": "kaleidoscope.6cd3c5f7.gif",
    "kZUOe": "light-trails.b9ebc7fd.gif",
    "1wMBv": "portal.3fde83f5.gif",
    "h8WUw": "fractals.0f002456.gif",
    "aGvM3": "kaleidoscope.2a2fd4b6.png",
    "kA7Jf": "light-trails.07f49621.png",
    "h7Btu": "portal.415445bd.png",
    "60pqL": "fractals.c4d7b2cf.png"
});

let $1f5a16020b51a07b$var$taskIdCounter = 1, $1f5a16020b51a07b$var$isCallbackScheduled = false, $1f5a16020b51a07b$var$isPerformingWork = false, $1f5a16020b51a07b$var$taskQueue = [], $1f5a16020b51a07b$var$currentTask = null, $1f5a16020b51a07b$var$shouldYieldToHost = null, $1f5a16020b51a07b$var$yieldInterval = 5, $1f5a16020b51a07b$var$deadline = 0, $1f5a16020b51a07b$var$maxYieldInterval = 300, $1f5a16020b51a07b$var$maxDeadline = 0, $1f5a16020b51a07b$var$scheduleCallback = null, $1f5a16020b51a07b$var$scheduledCallback = null;
const $1f5a16020b51a07b$var$maxSigned31BitInt = 1073741823;
function $1f5a16020b51a07b$var$setupScheduler() {
    const channel = new MessageChannel(), port1 = channel.port1, port = channel.port2;
    if (typeof port1.unref === "function") port1.unref();
    if (typeof port.unref === "function") port.unref();
    $1f5a16020b51a07b$var$scheduleCallback = ()=>port.postMessage(null);
    port1.onmessage = ()=>{
        if ($1f5a16020b51a07b$var$scheduledCallback !== null) {
            const currentTime = performance.now();
            $1f5a16020b51a07b$var$deadline = currentTime + $1f5a16020b51a07b$var$yieldInterval;
            $1f5a16020b51a07b$var$maxDeadline = currentTime + $1f5a16020b51a07b$var$maxYieldInterval;
            try {
                const hasMoreWork = $1f5a16020b51a07b$var$scheduledCallback(currentTime);
                if (!hasMoreWork) $1f5a16020b51a07b$var$scheduledCallback = null;
                else port.postMessage(null);
            } catch (error) {
                port.postMessage(null);
                throw error;
            }
        }
    };
    if (navigator && navigator.scheduling && navigator.scheduling.isInputPending) {
        const scheduling = navigator.scheduling;
        $1f5a16020b51a07b$var$shouldYieldToHost = ()=>{
            const currentTime = performance.now();
            if (currentTime >= $1f5a16020b51a07b$var$deadline) {
                if (scheduling.isInputPending()) return true;
                return currentTime >= $1f5a16020b51a07b$var$maxDeadline;
            } else return false;
        };
    } else $1f5a16020b51a07b$var$shouldYieldToHost = ()=>performance.now() >= $1f5a16020b51a07b$var$deadline;
}
function $1f5a16020b51a07b$var$enqueue(taskQueue, task) {
    function findIndex() {
        let m = 0;
        let n = taskQueue.length - 1;
        while(m <= n){
            const k = n + m >> 1;
            const cmp = task.expirationTime - taskQueue[k].expirationTime;
            if (cmp > 0) m = k + 1;
            else if (cmp < 0) n = k - 1;
            else return k;
        }
        return m;
    }
    taskQueue.splice(findIndex(), 0, task);
}
function $1f5a16020b51a07b$export$4b5e076b3a2fbe0a(fn, options) {
    if (!$1f5a16020b51a07b$var$scheduleCallback) $1f5a16020b51a07b$var$setupScheduler();
    let startTime = performance.now(), timeout = $1f5a16020b51a07b$var$maxSigned31BitInt;
    if (options && options.timeout) timeout = options.timeout;
    const newTask = {
        id: $1f5a16020b51a07b$var$taskIdCounter++,
        fn: fn,
        startTime: startTime,
        expirationTime: startTime + timeout
    };
    $1f5a16020b51a07b$var$enqueue($1f5a16020b51a07b$var$taskQueue, newTask);
    if (!$1f5a16020b51a07b$var$isCallbackScheduled && !$1f5a16020b51a07b$var$isPerformingWork) {
        $1f5a16020b51a07b$var$isCallbackScheduled = true;
        $1f5a16020b51a07b$var$scheduledCallback = $1f5a16020b51a07b$var$flushWork;
        $1f5a16020b51a07b$var$scheduleCallback();
    }
    return newTask;
}
function $1f5a16020b51a07b$export$b888d8f981c07a46(task) {
    task.fn = null;
}
function $1f5a16020b51a07b$var$flushWork(initialTime) {
    $1f5a16020b51a07b$var$isCallbackScheduled = false;
    $1f5a16020b51a07b$var$isPerformingWork = true;
    try {
        return $1f5a16020b51a07b$var$workLoop(initialTime);
    } finally{
        $1f5a16020b51a07b$var$currentTask = null;
        $1f5a16020b51a07b$var$isPerformingWork = false;
    }
}
function $1f5a16020b51a07b$var$workLoop(initialTime) {
    let currentTime = initialTime;
    $1f5a16020b51a07b$var$currentTask = $1f5a16020b51a07b$var$taskQueue[0] || null;
    while($1f5a16020b51a07b$var$currentTask !== null){
        if ($1f5a16020b51a07b$var$currentTask.expirationTime > currentTime && $1f5a16020b51a07b$var$shouldYieldToHost()) break;
        const callback = $1f5a16020b51a07b$var$currentTask.fn;
        if (callback !== null) {
            $1f5a16020b51a07b$var$currentTask.fn = null;
            const didUserCallbackTimeout = $1f5a16020b51a07b$var$currentTask.expirationTime <= currentTime;
            callback(didUserCallbackTimeout);
            currentTime = performance.now();
            if ($1f5a16020b51a07b$var$currentTask === $1f5a16020b51a07b$var$taskQueue[0]) $1f5a16020b51a07b$var$taskQueue.shift();
        } else $1f5a16020b51a07b$var$taskQueue.shift();
        $1f5a16020b51a07b$var$currentTask = $1f5a16020b51a07b$var$taskQueue[0] || null;
    }
    return $1f5a16020b51a07b$var$currentTask !== null;
}
const $1f5a16020b51a07b$export$2cb4986bed338027 = {
    context: undefined,
    registry: undefined,
    effects: undefined,
    done: false,
    getContextId () {
        return $1f5a16020b51a07b$var$getContextId(this.context.count);
    },
    getNextContextId () {
        return $1f5a16020b51a07b$var$getContextId(this.context.count++);
    }
};
function $1f5a16020b51a07b$var$getContextId(count) {
    const num = String(count), len = num.length - 1;
    return $1f5a16020b51a07b$export$2cb4986bed338027.context.id + (len ? String.fromCharCode(96 + len) : "") + num;
}
function $1f5a16020b51a07b$var$setHydrateContext(context) {
    $1f5a16020b51a07b$export$2cb4986bed338027.context = context;
}
function $1f5a16020b51a07b$var$nextHydrateContext() {
    return {
        ...$1f5a16020b51a07b$export$2cb4986bed338027.context,
        id: $1f5a16020b51a07b$export$2cb4986bed338027.getNextContextId(),
        count: 0
    };
}
const $1f5a16020b51a07b$var$IS_DEV = false;
const $1f5a16020b51a07b$export$34b67c27f2ca7498 = (a, b)=>a === b;
const $1f5a16020b51a07b$export$5cd89106e2f6c2c5 = Symbol("solid-proxy");
const $1f5a16020b51a07b$var$SUPPORTS_PROXY = typeof Proxy === "function";
const $1f5a16020b51a07b$export$17a675b7c02a7b1d = Symbol("solid-track");
const $1f5a16020b51a07b$export$f5625ae0b78e5b20 = Symbol("solid-dev-component");
const $1f5a16020b51a07b$var$signalOptions = {
    equals: $1f5a16020b51a07b$export$34b67c27f2ca7498
};
let $1f5a16020b51a07b$var$ERROR = null;
let $1f5a16020b51a07b$var$runEffects = $1f5a16020b51a07b$var$runQueue;
const $1f5a16020b51a07b$var$STALE = 1;
const $1f5a16020b51a07b$var$PENDING = 2;
const $1f5a16020b51a07b$var$UNOWNED = {
    owned: null,
    cleanups: null,
    context: null,
    owner: null
};
const $1f5a16020b51a07b$var$NO_INIT = {};
var $1f5a16020b51a07b$var$Owner = null;
let $1f5a16020b51a07b$var$Transition = null;
let $1f5a16020b51a07b$var$Scheduler = null;
let $1f5a16020b51a07b$var$ExternalSourceConfig = null;
let $1f5a16020b51a07b$var$Listener = null;
let $1f5a16020b51a07b$var$Updates = null;
let $1f5a16020b51a07b$var$Effects = null;
let $1f5a16020b51a07b$var$ExecCount = 0;
function $1f5a16020b51a07b$export$882461b6382ed46c(fn, detachedOwner) {
    const listener = $1f5a16020b51a07b$var$Listener, owner = $1f5a16020b51a07b$var$Owner, unowned = fn.length === 0, current = detachedOwner === undefined ? owner : detachedOwner, root = unowned ? $1f5a16020b51a07b$var$UNOWNED : {
        owned: null,
        cleanups: null,
        context: current ? current.context : null,
        owner: current
    }, updateFn = unowned ? fn : ()=>fn(()=>$1f5a16020b51a07b$export$363ebc4b78b8f807(()=>$1f5a16020b51a07b$var$cleanNode(root)));
    $1f5a16020b51a07b$var$Owner = root;
    $1f5a16020b51a07b$var$Listener = null;
    try {
        return $1f5a16020b51a07b$var$runUpdates(updateFn, true);
    } finally{
        $1f5a16020b51a07b$var$Listener = listener;
        $1f5a16020b51a07b$var$Owner = owner;
    }
}
function $1f5a16020b51a07b$export$c1e1e1ecbbe76a5(value, options) {
    options = options ? Object.assign({}, $1f5a16020b51a07b$var$signalOptions, options) : $1f5a16020b51a07b$var$signalOptions;
    const s = {
        value: value,
        observers: null,
        observerSlots: null,
        comparator: options.equals || undefined
    };
    const setter = (value)=>{
        if (typeof value === "function") {
            if ($1f5a16020b51a07b$var$Transition && $1f5a16020b51a07b$var$Transition.running && $1f5a16020b51a07b$var$Transition.sources.has(s)) value = value(s.tValue);
            else value = value(s.value);
        }
        return $1f5a16020b51a07b$var$writeSignal(s, value);
    };
    return [
        $1f5a16020b51a07b$var$readSignal.bind(s),
        setter
    ];
}
function $1f5a16020b51a07b$export$234a23cdc77e6a3d(fn, value, options) {
    const c = $1f5a16020b51a07b$var$createComputation(fn, value, true, $1f5a16020b51a07b$var$STALE);
    if ($1f5a16020b51a07b$var$Scheduler && $1f5a16020b51a07b$var$Transition && $1f5a16020b51a07b$var$Transition.running) $1f5a16020b51a07b$var$Updates.push(c);
    else $1f5a16020b51a07b$var$updateComputation(c);
}
function $1f5a16020b51a07b$export$314dade334ae905d(fn, value, options) {
    const c = $1f5a16020b51a07b$var$createComputation(fn, value, false, $1f5a16020b51a07b$var$STALE);
    if ($1f5a16020b51a07b$var$Scheduler && $1f5a16020b51a07b$var$Transition && $1f5a16020b51a07b$var$Transition.running) $1f5a16020b51a07b$var$Updates.push(c);
    else $1f5a16020b51a07b$var$updateComputation(c);
}
function $1f5a16020b51a07b$export$7ea7134f704deda4(fn, value, options) {
    $1f5a16020b51a07b$var$runEffects = $1f5a16020b51a07b$var$runUserEffects;
    const c = $1f5a16020b51a07b$var$createComputation(fn, value, false, $1f5a16020b51a07b$var$STALE), s = $1f5a16020b51a07b$var$SuspenseContext && $1f5a16020b51a07b$export$fae74005e78b1a27($1f5a16020b51a07b$var$SuspenseContext);
    if (s) c.suspense = s;
    if (!options || !options.render) c.user = true;
    $1f5a16020b51a07b$var$Effects ? $1f5a16020b51a07b$var$Effects.push(c) : $1f5a16020b51a07b$var$updateComputation(c);
}
function $1f5a16020b51a07b$export$5ce14d95ebb45542(onInvalidate, options) {
    let fn;
    const c = $1f5a16020b51a07b$var$createComputation(()=>{
        fn ? fn() : $1f5a16020b51a07b$export$363ebc4b78b8f807(onInvalidate);
        fn = undefined;
    }, undefined, false, 0), s = $1f5a16020b51a07b$var$SuspenseContext && $1f5a16020b51a07b$export$fae74005e78b1a27($1f5a16020b51a07b$var$SuspenseContext);
    if (s) c.suspense = s;
    c.user = true;
    return (tracking)=>{
        fn = tracking;
        $1f5a16020b51a07b$var$updateComputation(c);
    };
}
function $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa(fn, value, options) {
    options = options ? Object.assign({}, $1f5a16020b51a07b$var$signalOptions, options) : $1f5a16020b51a07b$var$signalOptions;
    const c = $1f5a16020b51a07b$var$createComputation(fn, value, true, 0);
    c.observers = null;
    c.observerSlots = null;
    c.comparator = options.equals || undefined;
    if ($1f5a16020b51a07b$var$Scheduler && $1f5a16020b51a07b$var$Transition && $1f5a16020b51a07b$var$Transition.running) {
        c.tState = $1f5a16020b51a07b$var$STALE;
        $1f5a16020b51a07b$var$Updates.push(c);
    } else $1f5a16020b51a07b$var$updateComputation(c);
    return $1f5a16020b51a07b$var$readSignal.bind(c);
}
function $1f5a16020b51a07b$var$isPromise(v) {
    return v && typeof v === "object" && "then" in v;
}
function $1f5a16020b51a07b$export$edd172c6c83c39cc(pSource, pFetcher, pOptions) {
    let source;
    let fetcher;
    let options;
    if (typeof pFetcher === "function") {
        source = pSource;
        fetcher = pFetcher;
        options = pOptions || {};
    } else {
        source = true;
        fetcher = pSource;
        options = pFetcher || {};
    }
    let pr = null, initP = $1f5a16020b51a07b$var$NO_INIT, id = null, loadedUnderTransition = false, scheduled = false, resolved = "initialValue" in options, dynamic = typeof source === "function" && $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa(source);
    const contexts = new Set(), [value, setValue] = (options.storage || $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(options.initialValue), [error, setError] = $1f5a16020b51a07b$export$c1e1e1ecbbe76a5(undefined), [track, trigger] = $1f5a16020b51a07b$export$c1e1e1ecbbe76a5(undefined, {
        equals: false
    }), [state, setState] = $1f5a16020b51a07b$export$c1e1e1ecbbe76a5(resolved ? "ready" : "unresolved");
    if ($1f5a16020b51a07b$export$2cb4986bed338027.context) {
        id = $1f5a16020b51a07b$export$2cb4986bed338027.getNextContextId();
        if (options.ssrLoadFrom === "initial") initP = options.initialValue;
        else if ($1f5a16020b51a07b$export$2cb4986bed338027.load && $1f5a16020b51a07b$export$2cb4986bed338027.has(id)) initP = $1f5a16020b51a07b$export$2cb4986bed338027.load(id);
    }
    function loadEnd(p, v, error, key) {
        if (pr === p) {
            pr = null;
            key !== undefined && (resolved = true);
            if ((p === initP || v === initP) && options.onHydrated) queueMicrotask(()=>options.onHydrated(key, {
                    value: v
                }));
            initP = $1f5a16020b51a07b$var$NO_INIT;
            if ($1f5a16020b51a07b$var$Transition && p && loadedUnderTransition) {
                $1f5a16020b51a07b$var$Transition.promises.delete(p);
                loadedUnderTransition = false;
                $1f5a16020b51a07b$var$runUpdates(()=>{
                    $1f5a16020b51a07b$var$Transition.running = true;
                    completeLoad(v, error);
                }, false);
            } else completeLoad(v, error);
        }
        return v;
    }
    function completeLoad(v, err) {
        $1f5a16020b51a07b$var$runUpdates(()=>{
            if (err === undefined) setValue(()=>v);
            setState(err !== undefined ? "errored" : resolved ? "ready" : "unresolved");
            setError(err);
            for (const c of contexts.keys())c.decrement();
            contexts.clear();
        }, false);
    }
    function read() {
        const c = $1f5a16020b51a07b$var$SuspenseContext && $1f5a16020b51a07b$export$fae74005e78b1a27($1f5a16020b51a07b$var$SuspenseContext), v = value(), err = error();
        if (err !== undefined && !pr) throw err;
        if ($1f5a16020b51a07b$var$Listener && !$1f5a16020b51a07b$var$Listener.user && c) $1f5a16020b51a07b$export$234a23cdc77e6a3d(()=>{
            track();
            if (pr) {
                if (c.resolved && $1f5a16020b51a07b$var$Transition && loadedUnderTransition) $1f5a16020b51a07b$var$Transition.promises.add(pr);
                else if (!contexts.has(c)) {
                    c.increment();
                    contexts.add(c);
                }
            }
        });
        return v;
    }
    function load(refetching = true) {
        if (refetching !== false && scheduled) return;
        scheduled = false;
        const lookup = dynamic ? dynamic() : source;
        loadedUnderTransition = $1f5a16020b51a07b$var$Transition && $1f5a16020b51a07b$var$Transition.running;
        if (lookup == null || lookup === false) {
            loadEnd(pr, $1f5a16020b51a07b$export$363ebc4b78b8f807(value));
            return;
        }
        if ($1f5a16020b51a07b$var$Transition && pr) $1f5a16020b51a07b$var$Transition.promises.delete(pr);
        let error;
        const p = initP !== $1f5a16020b51a07b$var$NO_INIT ? initP : $1f5a16020b51a07b$export$363ebc4b78b8f807(()=>{
            try {
                return fetcher(lookup, {
                    value: value(),
                    refetching: refetching
                });
            } catch (fetcherError) {
                error = fetcherError;
            }
        });
        if (error !== undefined) {
            loadEnd(pr, undefined, $1f5a16020b51a07b$var$castError(error), lookup);
            return;
        } else if (!$1f5a16020b51a07b$var$isPromise(p)) {
            loadEnd(pr, p, undefined, lookup);
            return p;
        }
        pr = p;
        if ("v" in p) {
            if (p.s === 1) loadEnd(pr, p.v, undefined, lookup);
            else loadEnd(pr, undefined, $1f5a16020b51a07b$var$castError(p.v), lookup);
            return p;
        }
        scheduled = true;
        queueMicrotask(()=>scheduled = false);
        $1f5a16020b51a07b$var$runUpdates(()=>{
            setState(resolved ? "refreshing" : "pending");
            trigger();
        }, false);
        return p.then((v)=>loadEnd(p, v, undefined, lookup), (e)=>loadEnd(p, undefined, $1f5a16020b51a07b$var$castError(e), lookup));
    }
    Object.defineProperties(read, {
        state: {
            get: ()=>state()
        },
        error: {
            get: ()=>error()
        },
        loading: {
            get () {
                const s = state();
                return s === "pending" || s === "refreshing";
            }
        },
        latest: {
            get () {
                if (!resolved) return read();
                const err = error();
                if (err && !pr) throw err;
                return value();
            }
        }
    });
    let owner = $1f5a16020b51a07b$var$Owner;
    if (dynamic) $1f5a16020b51a07b$export$234a23cdc77e6a3d(()=>(owner = $1f5a16020b51a07b$var$Owner, load(false)));
    else load(false);
    return [
        read,
        {
            refetch: (info)=>$1f5a16020b51a07b$export$c14f3e3abbc7d6b5(owner, ()=>load(info)),
            mutate: setValue
        }
    ];
}
function $1f5a16020b51a07b$export$e673efccd97e4223(source, options) {
    let t, timeout = options ? options.timeoutMs : undefined;
    const node = $1f5a16020b51a07b$var$createComputation(()=>{
        if (!t || !t.fn) t = $1f5a16020b51a07b$export$4b5e076b3a2fbe0a(()=>setDeferred(()=>node.value), timeout !== undefined ? {
            timeout: timeout
        } : undefined);
        return source();
    }, undefined, true);
    const [deferred, setDeferred] = $1f5a16020b51a07b$export$c1e1e1ecbbe76a5($1f5a16020b51a07b$var$Transition && $1f5a16020b51a07b$var$Transition.running && $1f5a16020b51a07b$var$Transition.sources.has(node) ? node.tValue : node.value, options);
    $1f5a16020b51a07b$var$updateComputation(node);
    setDeferred(()=>$1f5a16020b51a07b$var$Transition && $1f5a16020b51a07b$var$Transition.running && $1f5a16020b51a07b$var$Transition.sources.has(node) ? node.tValue : node.value);
    return deferred;
}
function $1f5a16020b51a07b$export$595d22ed68ca2841(source, fn = $1f5a16020b51a07b$export$34b67c27f2ca7498, options) {
    const subs = new Map();
    const node = $1f5a16020b51a07b$var$createComputation((p)=>{
        const v = source();
        for (const [key, val] of subs.entries())if (fn(key, v) !== fn(key, p)) for (const c of val.values()){
            c.state = $1f5a16020b51a07b$var$STALE;
            if (c.pure) $1f5a16020b51a07b$var$Updates.push(c);
            else $1f5a16020b51a07b$var$Effects.push(c);
        }
        return v;
    }, undefined, true, $1f5a16020b51a07b$var$STALE);
    $1f5a16020b51a07b$var$updateComputation(node);
    return (key)=>{
        const listener = $1f5a16020b51a07b$var$Listener;
        if (listener) {
            let l;
            if (l = subs.get(key)) l.add(listener);
            else subs.set(key, l = new Set([
                listener
            ]));
            $1f5a16020b51a07b$export$b36e5eaa3e8c43ab(()=>{
                l.delete(listener);
                !l.size && subs.delete(key);
            });
        }
        return fn(key, $1f5a16020b51a07b$var$Transition && $1f5a16020b51a07b$var$Transition.running && $1f5a16020b51a07b$var$Transition.sources.has(node) ? node.tValue : node.value);
    };
}
function $1f5a16020b51a07b$export$712ea50be43a7858(fn) {
    return $1f5a16020b51a07b$var$runUpdates(fn, false);
}
function $1f5a16020b51a07b$export$363ebc4b78b8f807(fn) {
    if (!$1f5a16020b51a07b$var$ExternalSourceConfig && $1f5a16020b51a07b$var$Listener === null) return fn();
    const listener = $1f5a16020b51a07b$var$Listener;
    $1f5a16020b51a07b$var$Listener = null;
    try {
        if ($1f5a16020b51a07b$var$ExternalSourceConfig) return $1f5a16020b51a07b$var$ExternalSourceConfig.untrack(fn);
        return fn();
    } finally{
        $1f5a16020b51a07b$var$Listener = listener;
    }
}
function $1f5a16020b51a07b$export$af631764ddc44097(deps, fn, options) {
    const isArray = Array.isArray(deps);
    let prevInput;
    let defer = options && options.defer;
    return (prevValue)=>{
        let input;
        if (isArray) {
            input = Array(deps.length);
            for(let i = 0; i < deps.length; i++)input[i] = deps[i]();
        } else input = deps();
        if (defer) {
            defer = false;
            return prevValue;
        }
        const result = $1f5a16020b51a07b$export$363ebc4b78b8f807(()=>fn(input, prevInput, prevValue));
        prevInput = input;
        return result;
    };
}
function $1f5a16020b51a07b$export$1e848a9e87980bd5(fn) {
    $1f5a16020b51a07b$export$7ea7134f704deda4(()=>$1f5a16020b51a07b$export$363ebc4b78b8f807(fn));
}
function $1f5a16020b51a07b$export$b36e5eaa3e8c43ab(fn) {
    if ($1f5a16020b51a07b$var$Owner === null) ;
    else if ($1f5a16020b51a07b$var$Owner.cleanups === null) $1f5a16020b51a07b$var$Owner.cleanups = [
        fn
    ];
    else $1f5a16020b51a07b$var$Owner.cleanups.push(fn);
    return fn;
}
function $1f5a16020b51a07b$export$3dede90624df3ba9(fn, handler) {
    $1f5a16020b51a07b$var$ERROR || ($1f5a16020b51a07b$var$ERROR = Symbol("error"));
    $1f5a16020b51a07b$var$Owner = $1f5a16020b51a07b$var$createComputation(undefined, undefined, true);
    $1f5a16020b51a07b$var$Owner.context = {
        ...$1f5a16020b51a07b$var$Owner.context,
        [$1f5a16020b51a07b$var$ERROR]: [
            handler
        ]
    };
    if ($1f5a16020b51a07b$var$Transition && $1f5a16020b51a07b$var$Transition.running) $1f5a16020b51a07b$var$Transition.sources.add($1f5a16020b51a07b$var$Owner);
    try {
        return fn();
    } catch (err) {
        $1f5a16020b51a07b$var$handleError(err);
    } finally{
        $1f5a16020b51a07b$var$Owner = $1f5a16020b51a07b$var$Owner.owner;
    }
}
function $1f5a16020b51a07b$export$12abb5141c6fdc9c() {
    return $1f5a16020b51a07b$var$Listener;
}
function $1f5a16020b51a07b$export$5f4ed0d56c2c0edf() {
    return $1f5a16020b51a07b$var$Owner;
}
function $1f5a16020b51a07b$export$c14f3e3abbc7d6b5(o, fn) {
    const prev = $1f5a16020b51a07b$var$Owner;
    const prevListener = $1f5a16020b51a07b$var$Listener;
    $1f5a16020b51a07b$var$Owner = o;
    $1f5a16020b51a07b$var$Listener = null;
    try {
        return $1f5a16020b51a07b$var$runUpdates(fn, true);
    } catch (err) {
        $1f5a16020b51a07b$var$handleError(err);
    } finally{
        $1f5a16020b51a07b$var$Owner = prev;
        $1f5a16020b51a07b$var$Listener = prevListener;
    }
}
function $1f5a16020b51a07b$export$45e8540700504e87(scheduler = $1f5a16020b51a07b$export$4b5e076b3a2fbe0a) {
    $1f5a16020b51a07b$var$Scheduler = scheduler;
}
function $1f5a16020b51a07b$export$7568632d0d33d16d(fn) {
    if ($1f5a16020b51a07b$var$Transition && $1f5a16020b51a07b$var$Transition.running) {
        fn();
        return $1f5a16020b51a07b$var$Transition.done;
    }
    const l = $1f5a16020b51a07b$var$Listener;
    const o = $1f5a16020b51a07b$var$Owner;
    return Promise.resolve().then(()=>{
        $1f5a16020b51a07b$var$Listener = l;
        $1f5a16020b51a07b$var$Owner = o;
        let t;
        if ($1f5a16020b51a07b$var$Scheduler || $1f5a16020b51a07b$var$SuspenseContext) {
            t = $1f5a16020b51a07b$var$Transition || ($1f5a16020b51a07b$var$Transition = {
                sources: new Set(),
                effects: [],
                promises: new Set(),
                disposed: new Set(),
                queue: new Set(),
                running: true
            });
            t.done || (t.done = new Promise((res)=>t.resolve = res));
            t.running = true;
        }
        $1f5a16020b51a07b$var$runUpdates(fn, false);
        $1f5a16020b51a07b$var$Listener = $1f5a16020b51a07b$var$Owner = null;
        return t ? t.done : undefined;
    });
}
const [$1f5a16020b51a07b$var$transPending, $1f5a16020b51a07b$var$setTransPending] = /*@__PURE__*/ $1f5a16020b51a07b$export$c1e1e1ecbbe76a5(false);
function $1f5a16020b51a07b$export$7b286972b8d8ccbf() {
    return [
        $1f5a16020b51a07b$var$transPending,
        $1f5a16020b51a07b$export$7568632d0d33d16d
    ];
}
function $1f5a16020b51a07b$var$resumeEffects(e) {
    $1f5a16020b51a07b$var$Effects.push.apply($1f5a16020b51a07b$var$Effects, e);
    e.length = 0;
}
function $1f5a16020b51a07b$export$fd42f52fd3ae1109(defaultValue, options) {
    const id = Symbol("context");
    return {
        id: id,
        Provider: $1f5a16020b51a07b$var$createProvider(id),
        defaultValue: defaultValue
    };
}
function $1f5a16020b51a07b$export$fae74005e78b1a27(context) {
    let value;
    return $1f5a16020b51a07b$var$Owner && $1f5a16020b51a07b$var$Owner.context && (value = $1f5a16020b51a07b$var$Owner.context[context.id]) !== undefined ? value : context.defaultValue;
}
function $1f5a16020b51a07b$export$bacb5cc5a11aef16(fn) {
    const children = $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa(fn);
    const memo = $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa(()=>$1f5a16020b51a07b$var$resolveChildren(children()));
    memo.toArray = ()=>{
        const c = memo();
        return Array.isArray(c) ? c : c != null ? [
            c
        ] : [];
    };
    return memo;
}
let $1f5a16020b51a07b$var$SuspenseContext;
function $1f5a16020b51a07b$var$getSuspenseContext() {
    return $1f5a16020b51a07b$var$SuspenseContext || ($1f5a16020b51a07b$var$SuspenseContext = $1f5a16020b51a07b$export$fd42f52fd3ae1109());
}
function $1f5a16020b51a07b$export$315ab94ce87a624f(factory, untrack = (fn)=>fn()) {
    if ($1f5a16020b51a07b$var$ExternalSourceConfig) {
        const { factory: oldFactory, untrack: oldUntrack } = $1f5a16020b51a07b$var$ExternalSourceConfig;
        $1f5a16020b51a07b$var$ExternalSourceConfig = {
            factory: (fn, trigger)=>{
                const oldSource = oldFactory(fn, trigger);
                const source = factory((x)=>oldSource.track(x), trigger);
                return {
                    track: (x)=>source.track(x),
                    dispose () {
                        source.dispose();
                        oldSource.dispose();
                    }
                };
            },
            untrack: (fn)=>oldUntrack(()=>untrack(fn))
        };
    } else $1f5a16020b51a07b$var$ExternalSourceConfig = {
        factory: factory,
        untrack: untrack
    };
}
function $1f5a16020b51a07b$var$readSignal() {
    const runningTransition = $1f5a16020b51a07b$var$Transition && $1f5a16020b51a07b$var$Transition.running;
    if (this.sources && (runningTransition ? this.tState : this.state)) {
        if ((runningTransition ? this.tState : this.state) === $1f5a16020b51a07b$var$STALE) $1f5a16020b51a07b$var$updateComputation(this);
        else {
            const updates = $1f5a16020b51a07b$var$Updates;
            $1f5a16020b51a07b$var$Updates = null;
            $1f5a16020b51a07b$var$runUpdates(()=>$1f5a16020b51a07b$var$lookUpstream(this), false);
            $1f5a16020b51a07b$var$Updates = updates;
        }
    }
    if ($1f5a16020b51a07b$var$Listener) {
        const observers = this.observers;
        if (!observers || observers[observers.length - 1] !== $1f5a16020b51a07b$var$Listener) {
            const sSlot = observers ? observers.length : 0;
            if (!$1f5a16020b51a07b$var$Listener.sources) {
                $1f5a16020b51a07b$var$Listener.sources = [
                    this
                ];
                $1f5a16020b51a07b$var$Listener.sourceSlots = [
                    sSlot
                ];
            } else {
                $1f5a16020b51a07b$var$Listener.sources.push(this);
                $1f5a16020b51a07b$var$Listener.sourceSlots.push(sSlot);
            }
            if (!observers) {
                this.observers = [
                    $1f5a16020b51a07b$var$Listener
                ];
                this.observerSlots = [
                    $1f5a16020b51a07b$var$Listener.sources.length - 1
                ];
            } else {
                observers.push($1f5a16020b51a07b$var$Listener);
                this.observerSlots.push($1f5a16020b51a07b$var$Listener.sources.length - 1);
            }
        }
    }
    if (runningTransition && $1f5a16020b51a07b$var$Transition.sources.has(this)) return this.tValue;
    return this.value;
}
function $1f5a16020b51a07b$var$writeSignal(node, value, isComp) {
    let current = $1f5a16020b51a07b$var$Transition && $1f5a16020b51a07b$var$Transition.running && $1f5a16020b51a07b$var$Transition.sources.has(node) ? node.tValue : node.value;
    if (!node.comparator || !node.comparator(current, value)) {
        if ($1f5a16020b51a07b$var$Transition) {
            const TransitionRunning = $1f5a16020b51a07b$var$Transition.running;
            if (TransitionRunning || !isComp && $1f5a16020b51a07b$var$Transition.sources.has(node)) {
                $1f5a16020b51a07b$var$Transition.sources.add(node);
                node.tValue = value;
            }
            if (!TransitionRunning) node.value = value;
        } else node.value = value;
        if (node.observers && node.observers.length) $1f5a16020b51a07b$var$runUpdates(()=>{
            for(let i = 0; i < node.observers.length; i += 1){
                const o = node.observers[i];
                const TransitionRunning = $1f5a16020b51a07b$var$Transition && $1f5a16020b51a07b$var$Transition.running;
                if (TransitionRunning && $1f5a16020b51a07b$var$Transition.disposed.has(o)) continue;
                if (TransitionRunning ? !o.tState : !o.state) {
                    if (o.pure) $1f5a16020b51a07b$var$Updates.push(o);
                    else $1f5a16020b51a07b$var$Effects.push(o);
                    if (o.observers) $1f5a16020b51a07b$var$markDownstream(o);
                }
                if (!TransitionRunning) o.state = $1f5a16020b51a07b$var$STALE;
                else o.tState = $1f5a16020b51a07b$var$STALE;
            }
            if ($1f5a16020b51a07b$var$Updates.length > 10e5) {
                $1f5a16020b51a07b$var$Updates = [];
                $1f5a16020b51a07b$var$IS_DEV;
                throw new Error();
            }
        }, false);
    }
    return value;
}
function $1f5a16020b51a07b$var$updateComputation(node) {
    if (!node.fn) return;
    $1f5a16020b51a07b$var$cleanNode(node);
    const time = $1f5a16020b51a07b$var$ExecCount;
    $1f5a16020b51a07b$var$runComputation(node, $1f5a16020b51a07b$var$Transition && $1f5a16020b51a07b$var$Transition.running && $1f5a16020b51a07b$var$Transition.sources.has(node) ? node.tValue : node.value, time);
    if ($1f5a16020b51a07b$var$Transition && !$1f5a16020b51a07b$var$Transition.running && $1f5a16020b51a07b$var$Transition.sources.has(node)) queueMicrotask(()=>{
        $1f5a16020b51a07b$var$runUpdates(()=>{
            $1f5a16020b51a07b$var$Transition && ($1f5a16020b51a07b$var$Transition.running = true);
            $1f5a16020b51a07b$var$Listener = $1f5a16020b51a07b$var$Owner = node;
            $1f5a16020b51a07b$var$runComputation(node, node.tValue, time);
            $1f5a16020b51a07b$var$Listener = $1f5a16020b51a07b$var$Owner = null;
        }, false);
    });
}
function $1f5a16020b51a07b$var$runComputation(node, value, time) {
    let nextValue;
    const owner = $1f5a16020b51a07b$var$Owner, listener = $1f5a16020b51a07b$var$Listener;
    $1f5a16020b51a07b$var$Listener = $1f5a16020b51a07b$var$Owner = node;
    try {
        nextValue = node.fn(value);
    } catch (err) {
        if (node.pure) {
            if ($1f5a16020b51a07b$var$Transition && $1f5a16020b51a07b$var$Transition.running) {
                node.tState = $1f5a16020b51a07b$var$STALE;
                node.tOwned && node.tOwned.forEach($1f5a16020b51a07b$var$cleanNode);
                node.tOwned = undefined;
            } else {
                node.state = $1f5a16020b51a07b$var$STALE;
                node.owned && node.owned.forEach($1f5a16020b51a07b$var$cleanNode);
                node.owned = null;
            }
        }
        node.updatedAt = time + 1;
        return $1f5a16020b51a07b$var$handleError(err);
    } finally{
        $1f5a16020b51a07b$var$Listener = listener;
        $1f5a16020b51a07b$var$Owner = owner;
    }
    if (!node.updatedAt || node.updatedAt <= time) {
        if (node.updatedAt != null && "observers" in node) $1f5a16020b51a07b$var$writeSignal(node, nextValue, true);
        else if ($1f5a16020b51a07b$var$Transition && $1f5a16020b51a07b$var$Transition.running && node.pure) {
            if (!$1f5a16020b51a07b$var$Transition.sources.has(node)) node.value = nextValue;
            $1f5a16020b51a07b$var$Transition.sources.add(node);
            node.tValue = nextValue;
        } else node.value = nextValue;
        node.updatedAt = time;
    }
}
function $1f5a16020b51a07b$var$createComputation(fn, init, pure, state = $1f5a16020b51a07b$var$STALE, options) {
    const c = {
        fn: fn,
        state: state,
        updatedAt: null,
        owned: null,
        sources: null,
        sourceSlots: null,
        cleanups: null,
        value: init,
        owner: $1f5a16020b51a07b$var$Owner,
        context: $1f5a16020b51a07b$var$Owner ? $1f5a16020b51a07b$var$Owner.context : null,
        pure: pure
    };
    if ($1f5a16020b51a07b$var$Transition && $1f5a16020b51a07b$var$Transition.running) {
        c.state = 0;
        c.tState = state;
    }
    if ($1f5a16020b51a07b$var$Owner === null) ;
    else if ($1f5a16020b51a07b$var$Owner !== $1f5a16020b51a07b$var$UNOWNED) {
        if ($1f5a16020b51a07b$var$Transition && $1f5a16020b51a07b$var$Transition.running && $1f5a16020b51a07b$var$Owner.pure) {
            if (!$1f5a16020b51a07b$var$Owner.tOwned) $1f5a16020b51a07b$var$Owner.tOwned = [
                c
            ];
            else $1f5a16020b51a07b$var$Owner.tOwned.push(c);
        } else if (!$1f5a16020b51a07b$var$Owner.owned) $1f5a16020b51a07b$var$Owner.owned = [
            c
        ];
        else $1f5a16020b51a07b$var$Owner.owned.push(c);
    }
    if ($1f5a16020b51a07b$var$ExternalSourceConfig && c.fn) {
        const sourceFn = c.fn;
        const [track, trigger] = $1f5a16020b51a07b$export$c1e1e1ecbbe76a5(undefined, {
            equals: false
        });
        const ordinary = $1f5a16020b51a07b$var$ExternalSourceConfig.factory(sourceFn, trigger);
        $1f5a16020b51a07b$export$b36e5eaa3e8c43ab(()=>ordinary.dispose());
        let inTransition;
        const triggerInTransition = ()=>$1f5a16020b51a07b$export$7568632d0d33d16d(trigger).then(()=>{
                if (inTransition) {
                    inTransition.dispose();
                    inTransition = undefined;
                }
            });
        c.fn = (x)=>{
            track();
            if ($1f5a16020b51a07b$var$Transition && $1f5a16020b51a07b$var$Transition.running) {
                if (!inTransition) inTransition = $1f5a16020b51a07b$var$ExternalSourceConfig.factory(sourceFn, triggerInTransition);
                return inTransition.track(x);
            }
            return ordinary.track(x);
        };
    }
    return c;
}
function $1f5a16020b51a07b$var$runTop(node) {
    const runningTransition = $1f5a16020b51a07b$var$Transition && $1f5a16020b51a07b$var$Transition.running;
    if ((runningTransition ? node.tState : node.state) === 0) return;
    if ((runningTransition ? node.tState : node.state) === $1f5a16020b51a07b$var$PENDING) return $1f5a16020b51a07b$var$lookUpstream(node);
    if (node.suspense && $1f5a16020b51a07b$export$363ebc4b78b8f807(node.suspense.inFallback)) return node.suspense.effects.push(node);
    const ancestors = [
        node
    ];
    while((node = node.owner) && (!node.updatedAt || node.updatedAt < $1f5a16020b51a07b$var$ExecCount)){
        if (runningTransition && $1f5a16020b51a07b$var$Transition.disposed.has(node)) return;
        if (runningTransition ? node.tState : node.state) ancestors.push(node);
    }
    for(let i = ancestors.length - 1; i >= 0; i--){
        node = ancestors[i];
        if (runningTransition) {
            let top = node, prev = ancestors[i + 1];
            while((top = top.owner) && top !== prev){
                if ($1f5a16020b51a07b$var$Transition.disposed.has(top)) return;
            }
        }
        if ((runningTransition ? node.tState : node.state) === $1f5a16020b51a07b$var$STALE) $1f5a16020b51a07b$var$updateComputation(node);
        else if ((runningTransition ? node.tState : node.state) === $1f5a16020b51a07b$var$PENDING) {
            const updates = $1f5a16020b51a07b$var$Updates;
            $1f5a16020b51a07b$var$Updates = null;
            $1f5a16020b51a07b$var$runUpdates(()=>$1f5a16020b51a07b$var$lookUpstream(node, ancestors[0]), false);
            $1f5a16020b51a07b$var$Updates = updates;
        }
    }
}
function $1f5a16020b51a07b$var$runUpdates(fn, init) {
    if ($1f5a16020b51a07b$var$Updates) return fn();
    let wait = false;
    if (!init) $1f5a16020b51a07b$var$Updates = [];
    if ($1f5a16020b51a07b$var$Effects) wait = true;
    else $1f5a16020b51a07b$var$Effects = [];
    $1f5a16020b51a07b$var$ExecCount++;
    try {
        const res = fn();
        $1f5a16020b51a07b$var$completeUpdates(wait);
        return res;
    } catch (err) {
        if (!wait) $1f5a16020b51a07b$var$Effects = null;
        $1f5a16020b51a07b$var$Updates = null;
        $1f5a16020b51a07b$var$handleError(err);
    }
}
function $1f5a16020b51a07b$var$completeUpdates(wait) {
    if ($1f5a16020b51a07b$var$Updates) {
        if ($1f5a16020b51a07b$var$Scheduler && $1f5a16020b51a07b$var$Transition && $1f5a16020b51a07b$var$Transition.running) $1f5a16020b51a07b$var$scheduleQueue($1f5a16020b51a07b$var$Updates);
        else $1f5a16020b51a07b$var$runQueue($1f5a16020b51a07b$var$Updates);
        $1f5a16020b51a07b$var$Updates = null;
    }
    if (wait) return;
    let res;
    if ($1f5a16020b51a07b$var$Transition) {
        if (!$1f5a16020b51a07b$var$Transition.promises.size && !$1f5a16020b51a07b$var$Transition.queue.size) {
            const sources = $1f5a16020b51a07b$var$Transition.sources;
            const disposed = $1f5a16020b51a07b$var$Transition.disposed;
            $1f5a16020b51a07b$var$Effects.push.apply($1f5a16020b51a07b$var$Effects, $1f5a16020b51a07b$var$Transition.effects);
            res = $1f5a16020b51a07b$var$Transition.resolve;
            for (const e of $1f5a16020b51a07b$var$Effects){
                "tState" in e && (e.state = e.tState);
                delete e.tState;
            }
            $1f5a16020b51a07b$var$Transition = null;
            $1f5a16020b51a07b$var$runUpdates(()=>{
                for (const d of disposed)$1f5a16020b51a07b$var$cleanNode(d);
                for (const v of sources){
                    v.value = v.tValue;
                    if (v.owned) for(let i = 0, len = v.owned.length; i < len; i++)$1f5a16020b51a07b$var$cleanNode(v.owned[i]);
                    if (v.tOwned) v.owned = v.tOwned;
                    delete v.tValue;
                    delete v.tOwned;
                    v.tState = 0;
                }
                $1f5a16020b51a07b$var$setTransPending(false);
            }, false);
        } else if ($1f5a16020b51a07b$var$Transition.running) {
            $1f5a16020b51a07b$var$Transition.running = false;
            $1f5a16020b51a07b$var$Transition.effects.push.apply($1f5a16020b51a07b$var$Transition.effects, $1f5a16020b51a07b$var$Effects);
            $1f5a16020b51a07b$var$Effects = null;
            $1f5a16020b51a07b$var$setTransPending(true);
            return;
        }
    }
    const e = $1f5a16020b51a07b$var$Effects;
    $1f5a16020b51a07b$var$Effects = null;
    if (e.length) $1f5a16020b51a07b$var$runUpdates(()=>$1f5a16020b51a07b$var$runEffects(e), false);
    if (res) res();
}
function $1f5a16020b51a07b$var$runQueue(queue) {
    for(let i = 0; i < queue.length; i++)$1f5a16020b51a07b$var$runTop(queue[i]);
}
function $1f5a16020b51a07b$var$scheduleQueue(queue) {
    for(let i = 0; i < queue.length; i++){
        const item = queue[i];
        const tasks = $1f5a16020b51a07b$var$Transition.queue;
        if (!tasks.has(item)) {
            tasks.add(item);
            $1f5a16020b51a07b$var$Scheduler(()=>{
                tasks.delete(item);
                $1f5a16020b51a07b$var$runUpdates(()=>{
                    $1f5a16020b51a07b$var$Transition.running = true;
                    $1f5a16020b51a07b$var$runTop(item);
                }, false);
                $1f5a16020b51a07b$var$Transition && ($1f5a16020b51a07b$var$Transition.running = false);
            });
        }
    }
}
function $1f5a16020b51a07b$var$runUserEffects(queue) {
    let i, userLength = 0;
    for(i = 0; i < queue.length; i++){
        const e = queue[i];
        if (!e.user) $1f5a16020b51a07b$var$runTop(e);
        else queue[userLength++] = e;
    }
    if ($1f5a16020b51a07b$export$2cb4986bed338027.context) {
        if ($1f5a16020b51a07b$export$2cb4986bed338027.count) {
            $1f5a16020b51a07b$export$2cb4986bed338027.effects || ($1f5a16020b51a07b$export$2cb4986bed338027.effects = []);
            $1f5a16020b51a07b$export$2cb4986bed338027.effects.push(...queue.slice(0, userLength));
            return;
        }
        $1f5a16020b51a07b$var$setHydrateContext();
    }
    if ($1f5a16020b51a07b$export$2cb4986bed338027.effects && ($1f5a16020b51a07b$export$2cb4986bed338027.done || !$1f5a16020b51a07b$export$2cb4986bed338027.count)) {
        queue = [
            ...$1f5a16020b51a07b$export$2cb4986bed338027.effects,
            ...queue
        ];
        userLength += $1f5a16020b51a07b$export$2cb4986bed338027.effects.length;
        delete $1f5a16020b51a07b$export$2cb4986bed338027.effects;
    }
    for(i = 0; i < userLength; i++)$1f5a16020b51a07b$var$runTop(queue[i]);
}
function $1f5a16020b51a07b$var$lookUpstream(node, ignore) {
    const runningTransition = $1f5a16020b51a07b$var$Transition && $1f5a16020b51a07b$var$Transition.running;
    if (runningTransition) node.tState = 0;
    else node.state = 0;
    for(let i = 0; i < node.sources.length; i += 1){
        const source = node.sources[i];
        if (source.sources) {
            const state = runningTransition ? source.tState : source.state;
            if (state === $1f5a16020b51a07b$var$STALE) {
                if (source !== ignore && (!source.updatedAt || source.updatedAt < $1f5a16020b51a07b$var$ExecCount)) $1f5a16020b51a07b$var$runTop(source);
            } else if (state === $1f5a16020b51a07b$var$PENDING) $1f5a16020b51a07b$var$lookUpstream(source, ignore);
        }
    }
}
function $1f5a16020b51a07b$var$markDownstream(node) {
    const runningTransition = $1f5a16020b51a07b$var$Transition && $1f5a16020b51a07b$var$Transition.running;
    for(let i = 0; i < node.observers.length; i += 1){
        const o = node.observers[i];
        if (runningTransition ? !o.tState : !o.state) {
            if (runningTransition) o.tState = $1f5a16020b51a07b$var$PENDING;
            else o.state = $1f5a16020b51a07b$var$PENDING;
            if (o.pure) $1f5a16020b51a07b$var$Updates.push(o);
            else $1f5a16020b51a07b$var$Effects.push(o);
            o.observers && $1f5a16020b51a07b$var$markDownstream(o);
        }
    }
}
function $1f5a16020b51a07b$var$cleanNode(node) {
    let i;
    if (node.sources) while(node.sources.length){
        const source = node.sources.pop(), index = node.sourceSlots.pop(), obs = source.observers;
        if (obs && obs.length) {
            const n = obs.pop(), s = source.observerSlots.pop();
            if (index < obs.length) {
                n.sourceSlots[s] = index;
                obs[index] = n;
                source.observerSlots[index] = s;
            }
        }
    }
    if (node.tOwned) {
        for(i = node.tOwned.length - 1; i >= 0; i--)$1f5a16020b51a07b$var$cleanNode(node.tOwned[i]);
        delete node.tOwned;
    }
    if ($1f5a16020b51a07b$var$Transition && $1f5a16020b51a07b$var$Transition.running && node.pure) $1f5a16020b51a07b$var$reset(node, true);
    else if (node.owned) {
        for(i = node.owned.length - 1; i >= 0; i--)$1f5a16020b51a07b$var$cleanNode(node.owned[i]);
        node.owned = null;
    }
    if (node.cleanups) {
        for(i = node.cleanups.length - 1; i >= 0; i--)node.cleanups[i]();
        node.cleanups = null;
    }
    if ($1f5a16020b51a07b$var$Transition && $1f5a16020b51a07b$var$Transition.running) node.tState = 0;
    else node.state = 0;
}
function $1f5a16020b51a07b$var$reset(node, top) {
    if (!top) {
        node.tState = 0;
        $1f5a16020b51a07b$var$Transition.disposed.add(node);
    }
    if (node.owned) for(let i = 0; i < node.owned.length; i++)$1f5a16020b51a07b$var$reset(node.owned[i]);
}
function $1f5a16020b51a07b$var$castError(err) {
    if (err instanceof Error) return err;
    return new Error(typeof err === "string" ? err : "Unknown error", {
        cause: err
    });
}
function $1f5a16020b51a07b$var$runErrors(err, fns, owner) {
    try {
        for (const f of fns)f(err);
    } catch (e) {
        $1f5a16020b51a07b$var$handleError(e, owner && owner.owner || null);
    }
}
function $1f5a16020b51a07b$var$handleError(err, owner = $1f5a16020b51a07b$var$Owner) {
    const fns = $1f5a16020b51a07b$var$ERROR && owner && owner.context && owner.context[$1f5a16020b51a07b$var$ERROR];
    const error = $1f5a16020b51a07b$var$castError(err);
    if (!fns) throw error;
    if ($1f5a16020b51a07b$var$Effects) $1f5a16020b51a07b$var$Effects.push({
        fn () {
            $1f5a16020b51a07b$var$runErrors(error, fns, owner);
        },
        state: $1f5a16020b51a07b$var$STALE
    });
    else $1f5a16020b51a07b$var$runErrors(error, fns, owner);
}
function $1f5a16020b51a07b$var$resolveChildren(children) {
    if (typeof children === "function" && !children.length) return $1f5a16020b51a07b$var$resolveChildren(children());
    if (Array.isArray(children)) {
        const results = [];
        for(let i = 0; i < children.length; i++){
            const result = $1f5a16020b51a07b$var$resolveChildren(children[i]);
            if (Array.isArray(result)) {
                if (result.length < 32768) results.push.apply(results, result);
                else for(let j = 0; j < result.length; j++)results.push(result[j]);
            } else results.push(result);
        }
        return results;
    }
    return children;
}
function $1f5a16020b51a07b$var$createProvider(id, options) {
    return function provider(props) {
        let res;
        $1f5a16020b51a07b$export$314dade334ae905d(()=>res = $1f5a16020b51a07b$export$363ebc4b78b8f807(()=>{
                $1f5a16020b51a07b$var$Owner.context = {
                    ...$1f5a16020b51a07b$var$Owner.context,
                    [id]: props.value
                };
                return $1f5a16020b51a07b$export$bacb5cc5a11aef16(()=>props.children);
            }), undefined);
        return res;
    };
}
function $1f5a16020b51a07b$export$2288787135a8f66e(fn) {
    $1f5a16020b51a07b$var$ERROR || ($1f5a16020b51a07b$var$ERROR = Symbol("error"));
    if ($1f5a16020b51a07b$var$Owner === null) ;
    else if ($1f5a16020b51a07b$var$Owner.context === null || !$1f5a16020b51a07b$var$Owner.context[$1f5a16020b51a07b$var$ERROR]) {
        $1f5a16020b51a07b$var$Owner.context = {
            ...$1f5a16020b51a07b$var$Owner.context,
            [$1f5a16020b51a07b$var$ERROR]: [
                fn
            ]
        };
        $1f5a16020b51a07b$var$mutateContext($1f5a16020b51a07b$var$Owner, $1f5a16020b51a07b$var$ERROR, [
            fn
        ]);
    } else $1f5a16020b51a07b$var$Owner.context[$1f5a16020b51a07b$var$ERROR].push(fn);
}
function $1f5a16020b51a07b$var$mutateContext(o, key, value) {
    if (o.owned) for(let i = 0; i < o.owned.length; i++){
        if (o.owned[i].context === o.context) $1f5a16020b51a07b$var$mutateContext(o.owned[i], key, value);
        if (!o.owned[i].context) {
            o.owned[i].context = o.context;
            $1f5a16020b51a07b$var$mutateContext(o.owned[i], key, value);
        } else if (!o.owned[i].context[key]) {
            o.owned[i].context[key] = value;
            $1f5a16020b51a07b$var$mutateContext(o.owned[i], key, value);
        }
    }
}
function $1f5a16020b51a07b$export$5ab46cbf6120b33a(input) {
    return {
        subscribe (observer) {
            if (!(observer instanceof Object) || observer == null) throw new TypeError("Expected the observer to be an object.");
            const handler = typeof observer === "function" ? observer : observer.next && observer.next.bind(observer);
            if (!handler) return {
                unsubscribe () {}
            };
            const dispose = $1f5a16020b51a07b$export$882461b6382ed46c((disposer)=>{
                $1f5a16020b51a07b$export$7ea7134f704deda4(()=>{
                    const v = input();
                    $1f5a16020b51a07b$export$363ebc4b78b8f807(()=>handler(v));
                });
                return disposer;
            });
            if ($1f5a16020b51a07b$export$5f4ed0d56c2c0edf()) $1f5a16020b51a07b$export$b36e5eaa3e8c43ab(dispose);
            return {
                unsubscribe () {
                    dispose();
                }
            };
        },
        [Symbol.observable || "@@observable"] () {
            return this;
        }
    };
}
function $1f5a16020b51a07b$export$6788812c4e6611e6(producer, initalValue) {
    const [s, set] = $1f5a16020b51a07b$export$c1e1e1ecbbe76a5(initalValue, {
        equals: false
    });
    if ("subscribe" in producer) {
        const unsub = producer.subscribe((v)=>set(()=>v));
        $1f5a16020b51a07b$export$b36e5eaa3e8c43ab(()=>"unsubscribe" in unsub ? unsub.unsubscribe() : unsub());
    } else {
        const clean = producer(set);
        $1f5a16020b51a07b$export$b36e5eaa3e8c43ab(clean);
    }
    return s;
}
const $1f5a16020b51a07b$var$FALLBACK = Symbol("fallback");
function $1f5a16020b51a07b$var$dispose(d) {
    for(let i = 0; i < d.length; i++)d[i]();
}
function $1f5a16020b51a07b$export$4c9116dcf1374231(list, mapFn, options = {}) {
    let items = [], mapped = [], disposers = [], len = 0, indexes = mapFn.length > 1 ? [] : null;
    $1f5a16020b51a07b$export$b36e5eaa3e8c43ab(()=>$1f5a16020b51a07b$var$dispose(disposers));
    return ()=>{
        let newItems = list() || [], newLen = newItems.length, i, j;
        newItems[$1f5a16020b51a07b$export$17a675b7c02a7b1d];
        return $1f5a16020b51a07b$export$363ebc4b78b8f807(()=>{
            let newIndices, newIndicesNext, temp, tempdisposers, tempIndexes, start, end, newEnd, item;
            if (newLen === 0) {
                if (len !== 0) {
                    $1f5a16020b51a07b$var$dispose(disposers);
                    disposers = [];
                    items = [];
                    mapped = [];
                    len = 0;
                    indexes && (indexes = []);
                }
                if (options.fallback) {
                    items = [
                        $1f5a16020b51a07b$var$FALLBACK
                    ];
                    mapped[0] = $1f5a16020b51a07b$export$882461b6382ed46c((disposer)=>{
                        disposers[0] = disposer;
                        return options.fallback();
                    });
                    len = 1;
                }
            } else if (len === 0) {
                mapped = new Array(newLen);
                for(j = 0; j < newLen; j++){
                    items[j] = newItems[j];
                    mapped[j] = $1f5a16020b51a07b$export$882461b6382ed46c(mapper);
                }
                len = newLen;
            } else {
                temp = new Array(newLen);
                tempdisposers = new Array(newLen);
                indexes && (tempIndexes = new Array(newLen));
                for(start = 0, end = Math.min(len, newLen); start < end && items[start] === newItems[start]; start++);
                for(end = len - 1, newEnd = newLen - 1; end >= start && newEnd >= start && items[end] === newItems[newEnd]; end--, newEnd--){
                    temp[newEnd] = mapped[end];
                    tempdisposers[newEnd] = disposers[end];
                    indexes && (tempIndexes[newEnd] = indexes[end]);
                }
                newIndices = new Map();
                newIndicesNext = new Array(newEnd + 1);
                for(j = newEnd; j >= start; j--){
                    item = newItems[j];
                    i = newIndices.get(item);
                    newIndicesNext[j] = i === undefined ? -1 : i;
                    newIndices.set(item, j);
                }
                for(i = start; i <= end; i++){
                    item = items[i];
                    j = newIndices.get(item);
                    if (j !== undefined && j !== -1) {
                        temp[j] = mapped[i];
                        tempdisposers[j] = disposers[i];
                        indexes && (tempIndexes[j] = indexes[i]);
                        j = newIndicesNext[j];
                        newIndices.set(item, j);
                    } else disposers[i]();
                }
                for(j = start; j < newLen; j++)if (j in temp) {
                    mapped[j] = temp[j];
                    disposers[j] = tempdisposers[j];
                    if (indexes) {
                        indexes[j] = tempIndexes[j];
                        indexes[j](j);
                    }
                } else mapped[j] = $1f5a16020b51a07b$export$882461b6382ed46c(mapper);
                mapped = mapped.slice(0, len = newLen);
                items = newItems.slice(0);
            }
            return mapped;
        });
        function mapper(disposer) {
            disposers[j] = disposer;
            if (indexes) {
                const [s, set] = $1f5a16020b51a07b$export$c1e1e1ecbbe76a5(j);
                indexes[j] = set;
                return mapFn(newItems[j], s);
            }
            return mapFn(newItems[j]);
        }
    };
}
function $1f5a16020b51a07b$export$2cd1c249765cd0a4(list, mapFn, options = {}) {
    let items = [], mapped = [], disposers = [], signals = [], len = 0, i;
    $1f5a16020b51a07b$export$b36e5eaa3e8c43ab(()=>$1f5a16020b51a07b$var$dispose(disposers));
    return ()=>{
        const newItems = list() || [], newLen = newItems.length;
        newItems[$1f5a16020b51a07b$export$17a675b7c02a7b1d];
        return $1f5a16020b51a07b$export$363ebc4b78b8f807(()=>{
            if (newLen === 0) {
                if (len !== 0) {
                    $1f5a16020b51a07b$var$dispose(disposers);
                    disposers = [];
                    items = [];
                    mapped = [];
                    len = 0;
                    signals = [];
                }
                if (options.fallback) {
                    items = [
                        $1f5a16020b51a07b$var$FALLBACK
                    ];
                    mapped[0] = $1f5a16020b51a07b$export$882461b6382ed46c((disposer)=>{
                        disposers[0] = disposer;
                        return options.fallback();
                    });
                    len = 1;
                }
                return mapped;
            }
            if (items[0] === $1f5a16020b51a07b$var$FALLBACK) {
                disposers[0]();
                disposers = [];
                items = [];
                mapped = [];
                len = 0;
            }
            for(i = 0; i < newLen; i++){
                if (i < items.length && items[i] !== newItems[i]) signals[i](()=>newItems[i]);
                else if (i >= items.length) mapped[i] = $1f5a16020b51a07b$export$882461b6382ed46c(mapper);
            }
            for(; i < items.length; i++)disposers[i]();
            len = signals.length = disposers.length = newLen;
            items = newItems.slice(0);
            return mapped = mapped.slice(0, len);
        });
        function mapper(disposer) {
            disposers[i] = disposer;
            const [s, set] = $1f5a16020b51a07b$export$c1e1e1ecbbe76a5(newItems[i]);
            signals[i] = set;
            return mapFn(s, i);
        }
    };
}
let $1f5a16020b51a07b$var$hydrationEnabled = false;
function $1f5a16020b51a07b$export$849801d35d2160c9() {
    $1f5a16020b51a07b$var$hydrationEnabled = true;
}
function $1f5a16020b51a07b$export$60e54eaca7e7fb38(Comp, props) {
    if ($1f5a16020b51a07b$var$hydrationEnabled) {
        if ($1f5a16020b51a07b$export$2cb4986bed338027.context) {
            const c = $1f5a16020b51a07b$export$2cb4986bed338027.context;
            $1f5a16020b51a07b$var$setHydrateContext($1f5a16020b51a07b$var$nextHydrateContext());
            const r = $1f5a16020b51a07b$export$363ebc4b78b8f807(()=>Comp(props || {}));
            $1f5a16020b51a07b$var$setHydrateContext(c);
            return r;
        }
    }
    return $1f5a16020b51a07b$export$363ebc4b78b8f807(()=>Comp(props || {}));
}
function $1f5a16020b51a07b$var$trueFn() {
    return true;
}
const $1f5a16020b51a07b$var$propTraps = {
    get (_, property, receiver) {
        if (property === $1f5a16020b51a07b$export$5cd89106e2f6c2c5) return receiver;
        return _.get(property);
    },
    has (_, property) {
        if (property === $1f5a16020b51a07b$export$5cd89106e2f6c2c5) return true;
        return _.has(property);
    },
    set: $1f5a16020b51a07b$var$trueFn,
    deleteProperty: $1f5a16020b51a07b$var$trueFn,
    getOwnPropertyDescriptor (_, property) {
        return {
            configurable: true,
            enumerable: true,
            get () {
                return _.get(property);
            },
            set: $1f5a16020b51a07b$var$trueFn,
            deleteProperty: $1f5a16020b51a07b$var$trueFn
        };
    },
    ownKeys (_) {
        return _.keys();
    }
};
function $1f5a16020b51a07b$var$resolveSource(s) {
    return !(s = typeof s === "function" ? s() : s) ? {} : s;
}
function $1f5a16020b51a07b$var$resolveSources() {
    for(let i = 0, length = this.length; i < length; ++i){
        const v = this[i]();
        if (v !== undefined) return v;
    }
}
function $1f5a16020b51a07b$export$9d1611c77c2fe928(...sources) {
    let proxy = false;
    for(let i = 0; i < sources.length; i++){
        const s = sources[i];
        proxy = proxy || !!s && $1f5a16020b51a07b$export$5cd89106e2f6c2c5 in s;
        sources[i] = typeof s === "function" ? (proxy = true, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa(s)) : s;
    }
    if ($1f5a16020b51a07b$var$SUPPORTS_PROXY && proxy) return new Proxy({
        get (property) {
            for(let i = sources.length - 1; i >= 0; i--){
                const v = $1f5a16020b51a07b$var$resolveSource(sources[i])[property];
                if (v !== undefined) return v;
            }
        },
        has (property) {
            for(let i = sources.length - 1; i >= 0; i--){
                if (property in $1f5a16020b51a07b$var$resolveSource(sources[i])) return true;
            }
            return false;
        },
        keys () {
            const keys = [];
            for(let i = 0; i < sources.length; i++)keys.push(...Object.keys($1f5a16020b51a07b$var$resolveSource(sources[i])));
            return [
                ...new Set(keys)
            ];
        }
    }, $1f5a16020b51a07b$var$propTraps);
    const sourcesMap = {};
    const defined = Object.create(null);
    for(let i = sources.length - 1; i >= 0; i--){
        const source = sources[i];
        if (!source) continue;
        const sourceKeys = Object.getOwnPropertyNames(source);
        for(let i = sourceKeys.length - 1; i >= 0; i--){
            const key = sourceKeys[i];
            if (key === "__proto__" || key === "constructor") continue;
            const desc = Object.getOwnPropertyDescriptor(source, key);
            if (!defined[key]) defined[key] = desc.get ? {
                enumerable: true,
                configurable: true,
                get: $1f5a16020b51a07b$var$resolveSources.bind(sourcesMap[key] = [
                    desc.get.bind(source)
                ])
            } : desc.value !== undefined ? desc : undefined;
            else {
                const sources = sourcesMap[key];
                if (sources) {
                    if (desc.get) sources.push(desc.get.bind(source));
                    else if (desc.value !== undefined) sources.push(()=>desc.value);
                }
            }
        }
    }
    const target = {};
    const definedKeys = Object.keys(defined);
    for(let i = definedKeys.length - 1; i >= 0; i--){
        const key = definedKeys[i], desc = defined[key];
        if (desc && desc.get) Object.defineProperty(target, key, desc);
        else target[key] = desc ? desc.value : undefined;
    }
    return target;
}
function $1f5a16020b51a07b$export$45029c61b0073d87(props, ...keys) {
    const len = keys.length;
    if ($1f5a16020b51a07b$var$SUPPORTS_PROXY && $1f5a16020b51a07b$export$5cd89106e2f6c2c5 in props) {
        const blocked = len > 1 ? keys.flat() : keys[0];
        const res = keys.map((k)=>{
            return new Proxy({
                get (property) {
                    return k.includes(property) ? props[property] : undefined;
                },
                has (property) {
                    return k.includes(property) && property in props;
                },
                keys () {
                    return k.filter((property)=>property in props);
                }
            }, $1f5a16020b51a07b$var$propTraps);
        });
        res.push(new Proxy({
            get (property) {
                return blocked.includes(property) ? undefined : props[property];
            },
            has (property) {
                return blocked.includes(property) ? false : property in props;
            },
            keys () {
                return Object.keys(props).filter((k)=>!blocked.includes(k));
            }
        }, $1f5a16020b51a07b$var$propTraps));
        return res;
    }
    const objects = [];
    for(let i = 0; i <= len; i++)objects[i] = {};
    for (const propName of Object.getOwnPropertyNames(props)){
        let keyIndex = len;
        for(let i = 0; i < keys.length; i++)if (keys[i].includes(propName)) {
            keyIndex = i;
            break;
        }
        const desc = Object.getOwnPropertyDescriptor(props, propName);
        const isDefaultDesc = !desc.get && !desc.set && desc.enumerable && desc.writable && desc.configurable;
        isDefaultDesc ? objects[keyIndex][propName] = desc.value : Object.defineProperty(objects[keyIndex], propName, desc);
    }
    return objects;
}
function $1f5a16020b51a07b$export$488013bae63b21da(fn) {
    let comp;
    let p;
    const wrap = (props)=>{
        const ctx = $1f5a16020b51a07b$export$2cb4986bed338027.context;
        if (ctx) {
            const [s, set] = $1f5a16020b51a07b$export$c1e1e1ecbbe76a5();
            $1f5a16020b51a07b$export$2cb4986bed338027.count || ($1f5a16020b51a07b$export$2cb4986bed338027.count = 0);
            $1f5a16020b51a07b$export$2cb4986bed338027.count++;
            (p || (p = fn())).then((mod)=>{
                !$1f5a16020b51a07b$export$2cb4986bed338027.done && $1f5a16020b51a07b$var$setHydrateContext(ctx);
                $1f5a16020b51a07b$export$2cb4986bed338027.count--;
                set(()=>mod.default);
                $1f5a16020b51a07b$var$setHydrateContext();
            });
            comp = s;
        } else if (!comp) {
            const [s] = $1f5a16020b51a07b$export$edd172c6c83c39cc(()=>(p || (p = fn())).then((mod)=>mod.default));
            comp = s;
        }
        let Comp;
        return $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa(()=>(Comp = comp()) ? $1f5a16020b51a07b$export$363ebc4b78b8f807(()=>{
                $1f5a16020b51a07b$var$IS_DEV;
                if (!ctx || $1f5a16020b51a07b$export$2cb4986bed338027.done) return Comp(props);
                const c = $1f5a16020b51a07b$export$2cb4986bed338027.context;
                $1f5a16020b51a07b$var$setHydrateContext(ctx);
                const r = Comp(props);
                $1f5a16020b51a07b$var$setHydrateContext(c);
                return r;
            }) : "");
    };
    wrap.preload = ()=>p || ((p = fn()).then((mod)=>comp = ()=>mod.default), p);
    return wrap;
}
let $1f5a16020b51a07b$var$counter = 0;
function $1f5a16020b51a07b$export$33208d63bc845a83() {
    const ctx = $1f5a16020b51a07b$export$2cb4986bed338027.context;
    return ctx ? $1f5a16020b51a07b$export$2cb4986bed338027.getNextContextId() : `cl-${$1f5a16020b51a07b$var$counter++}`;
}
const $1f5a16020b51a07b$var$narrowedError = (name)=>`Stale read from <${name}>.`;
function $1f5a16020b51a07b$export$bdf530073099ce9f(props) {
    const fallback = "fallback" in props && {
        fallback: ()=>props.fallback
    };
    return $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa($1f5a16020b51a07b$export$4c9116dcf1374231(()=>props.each, props.children, fallback || undefined));
}
function $1f5a16020b51a07b$export$cf17b003b6192af3(props) {
    const fallback = "fallback" in props && {
        fallback: ()=>props.fallback
    };
    return $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa($1f5a16020b51a07b$export$2cd1c249765cd0a4(()=>props.each, props.children, fallback || undefined));
}
function $1f5a16020b51a07b$export$f6a3d19be20f5819(props) {
    const keyed = props.keyed;
    const conditionValue = $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa(()=>props.when, undefined, undefined);
    const condition = keyed ? conditionValue : $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa(conditionValue, undefined, {
        equals: (a, b)=>!a === !b
    });
    return $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa(()=>{
        const c = condition();
        if (c) {
            const child = props.children;
            const fn = typeof child === "function" && child.length > 0;
            return fn ? $1f5a16020b51a07b$export$363ebc4b78b8f807(()=>child(keyed ? c : ()=>{
                    if (!$1f5a16020b51a07b$export$363ebc4b78b8f807(condition)) throw $1f5a16020b51a07b$var$narrowedError("Show");
                    return conditionValue();
                })) : child;
        }
        return props.fallback;
    }, undefined, undefined);
}
function $1f5a16020b51a07b$export$b5d5cf8927ab7262(props) {
    const chs = $1f5a16020b51a07b$export$bacb5cc5a11aef16(()=>props.children);
    const switchFunc = $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa(()=>{
        const ch = chs();
        const mps = Array.isArray(ch) ? ch : [
            ch
        ];
        let func = ()=>undefined;
        for(let i = 0; i < mps.length; i++){
            const index = i;
            const mp = mps[i];
            const prevFunc = func;
            const conditionValue = $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa(()=>prevFunc() ? undefined : mp.when, undefined, undefined);
            const condition = mp.keyed ? conditionValue : $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa(conditionValue, undefined, {
                equals: (a, b)=>!a === !b
            });
            func = ()=>prevFunc() || (condition() ? [
                    index,
                    conditionValue,
                    mp
                ] : undefined);
        }
        return func;
    });
    return $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa(()=>{
        const sel = switchFunc()();
        if (!sel) return props.fallback;
        const [index, conditionValue, mp] = sel;
        const child = mp.children;
        const fn = typeof child === "function" && child.length > 0;
        return fn ? $1f5a16020b51a07b$export$363ebc4b78b8f807(()=>child(mp.keyed ? conditionValue() : ()=>{
                if ($1f5a16020b51a07b$export$363ebc4b78b8f807(switchFunc)()?.[0] !== index) throw $1f5a16020b51a07b$var$narrowedError("Match");
                return conditionValue();
            })) : child;
    }, undefined, undefined);
}
function $1f5a16020b51a07b$export$f421feb8fad20413(props) {
    return props;
}
let $1f5a16020b51a07b$var$Errors;
function $1f5a16020b51a07b$export$4eaee74ee7a14dca() {
    $1f5a16020b51a07b$var$Errors && [
        ...$1f5a16020b51a07b$var$Errors
    ].forEach((fn)=>fn());
}
function $1f5a16020b51a07b$export$e926676385687eaf(props) {
    let err;
    if ($1f5a16020b51a07b$export$2cb4986bed338027.context && $1f5a16020b51a07b$export$2cb4986bed338027.load) err = $1f5a16020b51a07b$export$2cb4986bed338027.load($1f5a16020b51a07b$export$2cb4986bed338027.getContextId());
    const [errored, setErrored] = $1f5a16020b51a07b$export$c1e1e1ecbbe76a5(err, undefined);
    $1f5a16020b51a07b$var$Errors || ($1f5a16020b51a07b$var$Errors = new Set());
    $1f5a16020b51a07b$var$Errors.add(setErrored);
    $1f5a16020b51a07b$export$b36e5eaa3e8c43ab(()=>$1f5a16020b51a07b$var$Errors.delete(setErrored));
    return $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa(()=>{
        let e;
        if (e = errored()) {
            const f = props.fallback;
            return typeof f === "function" && f.length ? $1f5a16020b51a07b$export$363ebc4b78b8f807(()=>f(e, ()=>setErrored())) : f;
        }
        return $1f5a16020b51a07b$export$3dede90624df3ba9(()=>props.children, setErrored);
    }, undefined, undefined);
}
const $1f5a16020b51a07b$var$suspenseListEquals = (a, b)=>a.showContent === b.showContent && a.showFallback === b.showFallback;
const $1f5a16020b51a07b$var$SuspenseListContext = /* #__PURE__ */ $1f5a16020b51a07b$export$fd42f52fd3ae1109();
function $1f5a16020b51a07b$export$998bcd577473dd93(props) {
    let [wrapper, setWrapper] = $1f5a16020b51a07b$export$c1e1e1ecbbe76a5(()=>({
            inFallback: false
        })), show;
    const listContext = $1f5a16020b51a07b$export$fae74005e78b1a27($1f5a16020b51a07b$var$SuspenseListContext);
    const [registry, setRegistry] = $1f5a16020b51a07b$export$c1e1e1ecbbe76a5([]);
    if (listContext) show = listContext.register($1f5a16020b51a07b$export$c0c6c8b9c16bf6aa(()=>wrapper()().inFallback));
    const resolved = $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa((prev)=>{
        const reveal = props.revealOrder, tail = props.tail, { showContent: showContent = true, showFallback: showFallback = true } = show ? show() : {}, reg = registry(), reverse = reveal === "backwards";
        if (reveal === "together") {
            const all = reg.every((inFallback)=>!inFallback());
            const res = reg.map(()=>({
                    showContent: all && showContent,
                    showFallback: showFallback
                }));
            res.inFallback = !all;
            return res;
        }
        let stop = false;
        let inFallback = prev.inFallback;
        const res = [];
        for(let i = 0, len = reg.length; i < len; i++){
            const n = reverse ? len - i - 1 : i, s = reg[n]();
            if (!stop && !s) res[n] = {
                showContent: showContent,
                showFallback: showFallback
            };
            else {
                const next = !stop;
                if (next) inFallback = true;
                res[n] = {
                    showContent: next,
                    showFallback: !tail || next && tail === "collapsed" ? showFallback : false
                };
                stop = true;
            }
        }
        if (!stop) inFallback = false;
        res.inFallback = inFallback;
        return res;
    }, {
        inFallback: false
    });
    setWrapper(()=>resolved);
    return $1f5a16020b51a07b$export$60e54eaca7e7fb38($1f5a16020b51a07b$var$SuspenseListContext.Provider, {
        value: {
            register: (inFallback)=>{
                let index;
                setRegistry((registry)=>{
                    index = registry.length;
                    return [
                        ...registry,
                        inFallback
                    ];
                });
                return $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa(()=>resolved()[index], undefined, {
                    equals: $1f5a16020b51a07b$var$suspenseListEquals
                });
            }
        },
        get children () {
            return props.children;
        }
    });
}
function $1f5a16020b51a07b$export$74bf444e3cd11ea5(props) {
    let counter = 0, show, ctx, p, flicker, error;
    const [inFallback, setFallback] = $1f5a16020b51a07b$export$c1e1e1ecbbe76a5(false), SuspenseContext = $1f5a16020b51a07b$var$getSuspenseContext(), store = {
        increment: ()=>{
            if (++counter === 1) setFallback(true);
        },
        decrement: ()=>{
            if (--counter === 0) setFallback(false);
        },
        inFallback: inFallback,
        effects: [],
        resolved: false
    }, owner = $1f5a16020b51a07b$export$5f4ed0d56c2c0edf();
    if ($1f5a16020b51a07b$export$2cb4986bed338027.context && $1f5a16020b51a07b$export$2cb4986bed338027.load) {
        const key = $1f5a16020b51a07b$export$2cb4986bed338027.getContextId();
        let ref = $1f5a16020b51a07b$export$2cb4986bed338027.load(key);
        if (ref) {
            if (typeof ref !== "object" || ref.s !== 1) p = ref;
            else $1f5a16020b51a07b$export$2cb4986bed338027.gather(key);
        }
        if (p && p !== "$$f") {
            const [s, set] = $1f5a16020b51a07b$export$c1e1e1ecbbe76a5(undefined, {
                equals: false
            });
            flicker = s;
            p.then(()=>{
                if ($1f5a16020b51a07b$export$2cb4986bed338027.done) return set();
                $1f5a16020b51a07b$export$2cb4986bed338027.gather(key);
                $1f5a16020b51a07b$var$setHydrateContext(ctx);
                set();
                $1f5a16020b51a07b$var$setHydrateContext();
            }, (err)=>{
                error = err;
                set();
            });
        }
    }
    const listContext = $1f5a16020b51a07b$export$fae74005e78b1a27($1f5a16020b51a07b$var$SuspenseListContext);
    if (listContext) show = listContext.register(store.inFallback);
    let dispose;
    $1f5a16020b51a07b$export$b36e5eaa3e8c43ab(()=>dispose && dispose());
    return $1f5a16020b51a07b$export$60e54eaca7e7fb38(SuspenseContext.Provider, {
        value: store,
        get children () {
            return $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa(()=>{
                if (error) throw error;
                ctx = $1f5a16020b51a07b$export$2cb4986bed338027.context;
                if (flicker) {
                    flicker();
                    return flicker = undefined;
                }
                if (ctx && p === "$$f") $1f5a16020b51a07b$var$setHydrateContext();
                const rendered = $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa(()=>props.children);
                return $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa((prev)=>{
                    const inFallback = store.inFallback(), { showContent: showContent = true, showFallback: showFallback = true } = show ? show() : {};
                    if ((!inFallback || p && p !== "$$f") && showContent) {
                        store.resolved = true;
                        dispose && dispose();
                        dispose = ctx = p = undefined;
                        $1f5a16020b51a07b$var$resumeEffects(store.effects);
                        return rendered();
                    }
                    if (!showFallback) return;
                    if (dispose) return prev;
                    return $1f5a16020b51a07b$export$882461b6382ed46c((disposer)=>{
                        dispose = disposer;
                        if (ctx) {
                            $1f5a16020b51a07b$var$setHydrateContext({
                                id: ctx.id + "F",
                                count: 0
                            });
                            ctx = undefined;
                        }
                        return props.fallback;
                    }, owner);
                });
            });
        }
    });
}
const $1f5a16020b51a07b$export$404582bc18fe4d9e = undefined;


const $fb40d00dea10da1a$var$booleans = [
    "allowfullscreen",
    "async",
    "alpha",
    "autofocus",
    "autoplay",
    "checked",
    "controls",
    "default",
    "disabled",
    "formnovalidate",
    "hidden",
    "indeterminate",
    "inert",
    "ismap",
    "loop",
    "multiple",
    "muted",
    "nomodule",
    "novalidate",
    "open",
    "playsinline",
    "readonly",
    "required",
    "reversed",
    "seamless",
    "selected",
    "adauctionheaders",
    "browsingtopics",
    "credentialless",
    "defaultchecked",
    "defaultmuted",
    "defaultselected",
    "defer",
    "disablepictureinpicture",
    "disableremoteplayback",
    "preservespitch",
    "shadowrootclonable",
    "shadowrootcustomelementregistry",
    "shadowrootdelegatesfocus",
    "shadowrootserializable",
    "sharedstoragewritable"
];
const $fb40d00dea10da1a$export$8714badcfa4caafb = /*#__PURE__*/ new Set([
    "className",
    "value",
    "readOnly",
    "noValidate",
    "formNoValidate",
    "isMap",
    "noModule",
    "playsInline",
    "adAuctionHeaders",
    "allowFullscreen",
    "browsingTopics",
    "defaultChecked",
    "defaultMuted",
    "defaultSelected",
    "disablePictureInPicture",
    "disableRemotePlayback",
    "preservesPitch",
    "shadowRootClonable",
    "shadowRootCustomElementRegistry",
    "shadowRootDelegatesFocus",
    "shadowRootSerializable",
    "sharedStorageWritable",
    ...$fb40d00dea10da1a$var$booleans
]);
const $fb40d00dea10da1a$export$2c72a9edec54d5d9 = /*#__PURE__*/ new Set([
    "innerHTML",
    "textContent",
    "innerText",
    "children"
]);
const $fb40d00dea10da1a$export$8915b7db7f70cfed = /*#__PURE__*/ Object.assign(Object.create(null), {
    className: "class",
    htmlFor: "for"
});
const $fb40d00dea10da1a$var$PropAliases = /*#__PURE__*/ Object.assign(Object.create(null), {
    class: "className",
    novalidate: {
        $: "noValidate",
        FORM: 1
    },
    formnovalidate: {
        $: "formNoValidate",
        BUTTON: 1,
        INPUT: 1
    },
    ismap: {
        $: "isMap",
        IMG: 1
    },
    nomodule: {
        $: "noModule",
        SCRIPT: 1
    },
    playsinline: {
        $: "playsInline",
        VIDEO: 1
    },
    readonly: {
        $: "readOnly",
        INPUT: 1,
        TEXTAREA: 1
    },
    adauctionheaders: {
        $: "adAuctionHeaders",
        IFRAME: 1
    },
    allowfullscreen: {
        $: "allowFullscreen",
        IFRAME: 1
    },
    browsingtopics: {
        $: "browsingTopics",
        IMG: 1
    },
    defaultchecked: {
        $: "defaultChecked",
        INPUT: 1
    },
    defaultmuted: {
        $: "defaultMuted",
        AUDIO: 1,
        VIDEO: 1
    },
    defaultselected: {
        $: "defaultSelected",
        OPTION: 1
    },
    disablepictureinpicture: {
        $: "disablePictureInPicture",
        VIDEO: 1
    },
    disableremoteplayback: {
        $: "disableRemotePlayback",
        AUDIO: 1,
        VIDEO: 1
    },
    preservespitch: {
        $: "preservesPitch",
        AUDIO: 1,
        VIDEO: 1
    },
    shadowrootclonable: {
        $: "shadowRootClonable",
        TEMPLATE: 1
    },
    shadowrootdelegatesfocus: {
        $: "shadowRootDelegatesFocus",
        TEMPLATE: 1
    },
    shadowrootserializable: {
        $: "shadowRootSerializable",
        TEMPLATE: 1
    },
    sharedstoragewritable: {
        $: "sharedStorageWritable",
        IFRAME: 1,
        IMG: 1
    }
});
function $fb40d00dea10da1a$export$72dcdd3761a309a9(prop, tagName) {
    const a = $fb40d00dea10da1a$var$PropAliases[prop];
    return typeof a === "object" ? a[tagName] ? a["$"] : undefined : a;
}
const $fb40d00dea10da1a$export$389d7c657d123a81 = /*#__PURE__*/ new Set([
    "beforeinput",
    "click",
    "dblclick",
    "contextmenu",
    "focusin",
    "focusout",
    "input",
    "keydown",
    "keyup",
    "mousedown",
    "mousemove",
    "mouseout",
    "mouseover",
    "mouseup",
    "pointerdown",
    "pointermove",
    "pointerout",
    "pointerover",
    "pointerup",
    "touchend",
    "touchmove",
    "touchstart"
]);
const $fb40d00dea10da1a$export$ccaf9b9a82de4b98 = /*#__PURE__*/ new Set([
    "altGlyph",
    "altGlyphDef",
    "altGlyphItem",
    "animate",
    "animateColor",
    "animateMotion",
    "animateTransform",
    "circle",
    "clipPath",
    "color-profile",
    "cursor",
    "defs",
    "desc",
    "ellipse",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "filter",
    "font",
    "font-face",
    "font-face-format",
    "font-face-name",
    "font-face-src",
    "font-face-uri",
    "foreignObject",
    "g",
    "glyph",
    "glyphRef",
    "hkern",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "metadata",
    "missing-glyph",
    "mpath",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "set",
    "stop",
    "svg",
    "switch",
    "symbol",
    "text",
    "textPath",
    "tref",
    "tspan",
    "use",
    "view",
    "vkern"
]);
const $fb40d00dea10da1a$export$fa927d1d0495a67d = {
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace"
};
const $fb40d00dea10da1a$export$87d0e790667228e9 = /*#__PURE__*/ new Set([
    "html",
    "base",
    "head",
    "link",
    "meta",
    "style",
    "title",
    "body",
    "address",
    "article",
    "aside",
    "footer",
    "header",
    "main",
    "nav",
    "section",
    "body",
    "blockquote",
    "dd",
    "div",
    "dl",
    "dt",
    "figcaption",
    "figure",
    "hr",
    "li",
    "ol",
    "p",
    "pre",
    "ul",
    "a",
    "abbr",
    "b",
    "bdi",
    "bdo",
    "br",
    "cite",
    "code",
    "data",
    "dfn",
    "em",
    "i",
    "kbd",
    "mark",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "small",
    "span",
    "strong",
    "sub",
    "sup",
    "time",
    "u",
    "var",
    "wbr",
    "area",
    "audio",
    "img",
    "map",
    "track",
    "video",
    "embed",
    "iframe",
    "object",
    "param",
    "picture",
    "portal",
    "source",
    "svg",
    "math",
    "canvas",
    "noscript",
    "script",
    "del",
    "ins",
    "caption",
    "col",
    "colgroup",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "tr",
    "button",
    "datalist",
    "fieldset",
    "form",
    "input",
    "label",
    "legend",
    "meter",
    "optgroup",
    "option",
    "output",
    "progress",
    "select",
    "textarea",
    "details",
    "dialog",
    "menu",
    "summary",
    "details",
    "slot",
    "template",
    "acronym",
    "applet",
    "basefont",
    "bgsound",
    "big",
    "blink",
    "center",
    "content",
    "dir",
    "font",
    "frame",
    "frameset",
    "hgroup",
    "image",
    "keygen",
    "marquee",
    "menuitem",
    "nobr",
    "noembed",
    "noframes",
    "plaintext",
    "rb",
    "rtc",
    "shadow",
    "spacer",
    "strike",
    "tt",
    "xmp",
    "a",
    "abbr",
    "acronym",
    "address",
    "applet",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "basefont",
    "bdi",
    "bdo",
    "bgsound",
    "big",
    "blink",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "center",
    "cite",
    "code",
    "col",
    "colgroup",
    "content",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "dir",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "font",
    "footer",
    "form",
    "frame",
    "frameset",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "image",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "nobr",
    "noembed",
    "noframes",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "plaintext",
    "portal",
    "pre",
    "progress",
    "q",
    "rb",
    "rp",
    "rt",
    "rtc",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "shadow",
    "slot",
    "small",
    "source",
    "spacer",
    "span",
    "strike",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "template",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "tt",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "xmp",
    "input",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "webview",
    "isindex",
    "listing",
    "multicol",
    "nextid",
    "noindex",
    "search"
]);
const $fb40d00dea10da1a$export$7c73462e0d25e514 = (fn)=>(0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>fn());
function $fb40d00dea10da1a$var$reconcileArrays(parentNode, a, b) {
    let bLength = b.length, aEnd = a.length, bEnd = bLength, aStart = 0, bStart = 0, after = a[aEnd - 1].nextSibling, map = null;
    while(aStart < aEnd || bStart < bEnd){
        if (a[aStart] === b[bStart]) {
            aStart++;
            bStart++;
            continue;
        }
        while(a[aEnd - 1] === b[bEnd - 1]){
            aEnd--;
            bEnd--;
        }
        if (aEnd === aStart) {
            const node = bEnd < bLength ? bStart ? b[bStart - 1].nextSibling : b[bEnd - bStart] : after;
            while(bStart < bEnd)parentNode.insertBefore(b[bStart++], node);
        } else if (bEnd === bStart) while(aStart < aEnd){
            if (!map || !map.has(a[aStart])) a[aStart].remove();
            aStart++;
        }
        else if (a[aStart] === b[bEnd - 1] && b[bStart] === a[aEnd - 1]) {
            const node = a[--aEnd].nextSibling;
            parentNode.insertBefore(b[bStart++], a[aStart++].nextSibling);
            parentNode.insertBefore(b[--bEnd], node);
            a[aEnd] = b[bEnd];
        } else {
            if (!map) {
                map = new Map();
                let i = bStart;
                while(i < bEnd)map.set(b[i], i++);
            }
            const index = map.get(a[aStart]);
            if (index != null) {
                if (bStart < index && index < bEnd) {
                    let i = aStart, sequence = 1, t;
                    while(++i < aEnd && i < bEnd){
                        if ((t = map.get(a[i])) == null || t !== index + sequence) break;
                        sequence++;
                    }
                    if (sequence > index - bStart) {
                        const node = a[aStart];
                        while(bStart < index)parentNode.insertBefore(b[bStart++], node);
                    } else parentNode.replaceChild(b[bStart++], a[aStart++]);
                } else aStart++;
            } else a[aStart++].remove();
        }
    }
}
const $fb40d00dea10da1a$var$$$EVENTS = "_$DX_DELEGATE";
function $fb40d00dea10da1a$export$b3890eb0ae9dca99(code, element, init, options = {}) {
    let disposer;
    (0, $1f5a16020b51a07b$export$882461b6382ed46c)((dispose)=>{
        disposer = dispose;
        element === document ? code() : $fb40d00dea10da1a$export$21a5ca8aa77d35ff(element, code(), element.firstChild ? null : undefined, init);
    }, options.owner);
    return ()=>{
        disposer();
        element.textContent = "";
    };
}
function $fb40d00dea10da1a$export$ce69bd05624d0c48(html, isImportNode, isSVG, isMathML) {
    let node;
    const create = ()=>{
        const t = isMathML ? document.createElementNS("http://www.w3.org/1998/Math/MathML", "template") : document.createElement("template");
        t.innerHTML = html;
        return isSVG ? t.content.firstChild.firstChild : isMathML ? t.firstChild : t.content.firstChild;
    };
    const fn = isImportNode ? ()=>(0, $1f5a16020b51a07b$export$363ebc4b78b8f807)(()=>document.importNode(node || (node = create()), true)) : ()=>(node || (node = create())).cloneNode(true);
    fn.cloneNode = fn;
    return fn;
}
function $fb40d00dea10da1a$export$ad0f7f87f67e17d6(eventNames, document1 = window.document) {
    const e = document1[$fb40d00dea10da1a$var$$$EVENTS] || (document1[$fb40d00dea10da1a$var$$$EVENTS] = new Set());
    for(let i = 0, l = eventNames.length; i < l; i++){
        const name = eventNames[i];
        if (!e.has(name)) {
            e.add(name);
            document1.addEventListener(name, $fb40d00dea10da1a$var$eventHandler);
        }
    }
}
function $fb40d00dea10da1a$export$aedd29ca2033b694(document1 = window.document) {
    if (document1[$fb40d00dea10da1a$var$$$EVENTS]) {
        for (let name of document1[$fb40d00dea10da1a$var$$$EVENTS].keys())document1.removeEventListener(name, $fb40d00dea10da1a$var$eventHandler);
        delete document1[$fb40d00dea10da1a$var$$$EVENTS];
    }
}
function $fb40d00dea10da1a$export$a41c68a4eb5ff164(node, name, value) {
    if ($fb40d00dea10da1a$var$isHydrating(node)) return;
    node[name] = value;
}
function $fb40d00dea10da1a$export$9fec4d97f1922e0b(node, name, value) {
    if ($fb40d00dea10da1a$var$isHydrating(node)) return;
    if (value == null) node.removeAttribute(name);
    else node.setAttribute(name, value);
}
function $fb40d00dea10da1a$export$75900142c9e21800(node, namespace, name, value) {
    if ($fb40d00dea10da1a$var$isHydrating(node)) return;
    if (value == null) node.removeAttributeNS(namespace, name);
    else node.setAttributeNS(namespace, name, value);
}
function $fb40d00dea10da1a$export$248913d9a30bef7a(node, name, value) {
    if ($fb40d00dea10da1a$var$isHydrating(node)) return;
    value ? node.setAttribute(name, "") : node.removeAttribute(name);
}
function $fb40d00dea10da1a$export$2913c0c0b5623090(node, value) {
    if ($fb40d00dea10da1a$var$isHydrating(node)) return;
    if (value == null) node.removeAttribute("class");
    else node.className = value;
}
function $fb40d00dea10da1a$export$3f65cefe8380dbea(node, name, handler, delegate) {
    if (delegate) {
        if (Array.isArray(handler)) {
            node[`$$${name}`] = handler[0];
            node[`$$${name}Data`] = handler[1];
        } else node[`$$${name}`] = handler;
    } else if (Array.isArray(handler)) {
        const handlerFn = handler[0];
        node.addEventListener(name, handler[0] = (e)=>handlerFn.call(node, handler[1], e));
    } else node.addEventListener(name, handler, typeof handler !== "function" && handler);
}
function $fb40d00dea10da1a$export$11c615ce16f87241(node, value, prev = {}) {
    const classKeys = Object.keys(value || {}), prevKeys = Object.keys(prev);
    let i, len;
    for(i = 0, len = prevKeys.length; i < len; i++){
        const key = prevKeys[i];
        if (!key || key === "undefined" || value[key]) continue;
        $fb40d00dea10da1a$var$toggleClassKey(node, key, false);
        delete prev[key];
    }
    for(i = 0, len = classKeys.length; i < len; i++){
        const key = classKeys[i], classValue = !!value[key];
        if (!key || key === "undefined" || prev[key] === classValue || !classValue) continue;
        $fb40d00dea10da1a$var$toggleClassKey(node, key, true);
        prev[key] = classValue;
    }
    return prev;
}
function $fb40d00dea10da1a$export$1d567c320f4763bc(node, value, prev) {
    if (!value) return prev ? $fb40d00dea10da1a$export$9fec4d97f1922e0b(node, "style") : value;
    const nodeStyle = node.style;
    if (typeof value === "string") return nodeStyle.cssText = value;
    typeof prev === "string" && (nodeStyle.cssText = prev = undefined);
    prev || (prev = {});
    value || (value = {});
    let v, s;
    for(s in prev){
        value[s] == null && nodeStyle.removeProperty(s);
        delete prev[s];
    }
    for(s in value){
        v = value[s];
        if (v !== prev[s]) {
            nodeStyle.setProperty(s, v);
            prev[s] = v;
        }
    }
    return prev;
}
function $fb40d00dea10da1a$export$36a7c0615a5a1a31(node, name, value) {
    value != null ? node.style.setProperty(name, value) : node.style.removeProperty(name);
}
function $fb40d00dea10da1a$export$3ae0fd4797ed47c8(node, props = {}, isSVG, skipChildren) {
    const prevProps = {};
    if (!skipChildren) (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>prevProps.children = $fb40d00dea10da1a$var$insertExpression(node, props.children, prevProps.children));
    (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>typeof props.ref === "function" && $fb40d00dea10da1a$export$1f96ae73734a86cc(props.ref, node));
    (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>$fb40d00dea10da1a$export$e6e34fd1f2686227(node, props, isSVG, true, prevProps, true));
    return prevProps;
}
function $fb40d00dea10da1a$export$2810486c22c942e9(props, key) {
    const src = props[key];
    Object.defineProperty(props, key, {
        get () {
            return src();
        },
        enumerable: true
    });
    return props;
}
function $fb40d00dea10da1a$export$1f96ae73734a86cc(fn, element, arg) {
    return (0, $1f5a16020b51a07b$export$363ebc4b78b8f807)(()=>fn(element, arg));
}
function $fb40d00dea10da1a$export$21a5ca8aa77d35ff(parent, accessor, marker, initial) {
    if (marker !== undefined && !initial) initial = [];
    if (typeof accessor !== "function") return $fb40d00dea10da1a$var$insertExpression(parent, accessor, initial, marker);
    (0, $1f5a16020b51a07b$export$314dade334ae905d)((current)=>$fb40d00dea10da1a$var$insertExpression(parent, accessor(), current, marker), initial);
}
function $fb40d00dea10da1a$export$e6e34fd1f2686227(node, props, isSVG, skipChildren, prevProps = {}, skipRef = false) {
    props || (props = {});
    for(const prop in prevProps)if (!(prop in props)) {
        if (prop === "children") continue;
        prevProps[prop] = $fb40d00dea10da1a$var$assignProp(node, prop, null, prevProps[prop], isSVG, skipRef, props);
    }
    for(const prop in props){
        if (prop === "children") {
            if (!skipChildren) $fb40d00dea10da1a$var$insertExpression(node, props.children);
            continue;
        }
        const value = props[prop];
        prevProps[prop] = $fb40d00dea10da1a$var$assignProp(node, prop, value, prevProps[prop], isSVG, skipRef, props);
    }
}
function $fb40d00dea10da1a$var$hydrate$1(code, element, options = {}) {
    if (globalThis._$HY.done) return $fb40d00dea10da1a$export$b3890eb0ae9dca99(code, element, [
        ...element.childNodes
    ], options);
    (0, $1f5a16020b51a07b$export$2cb4986bed338027).completed = globalThis._$HY.completed;
    (0, $1f5a16020b51a07b$export$2cb4986bed338027).events = globalThis._$HY.events;
    (0, $1f5a16020b51a07b$export$2cb4986bed338027).load = (id)=>globalThis._$HY.r[id];
    (0, $1f5a16020b51a07b$export$2cb4986bed338027).has = (id)=>id in globalThis._$HY.r;
    (0, $1f5a16020b51a07b$export$2cb4986bed338027).gather = (root)=>$fb40d00dea10da1a$var$gatherHydratable(element, root);
    (0, $1f5a16020b51a07b$export$2cb4986bed338027).registry = new Map();
    (0, $1f5a16020b51a07b$export$2cb4986bed338027).context = {
        id: options.renderId || "",
        count: 0
    };
    try {
        $fb40d00dea10da1a$var$gatherHydratable(element, options.renderId);
        return $fb40d00dea10da1a$export$b3890eb0ae9dca99(code, element, [
            ...element.childNodes
        ], options);
    } finally{
        (0, $1f5a16020b51a07b$export$2cb4986bed338027).context = null;
    }
}
function $fb40d00dea10da1a$export$4109ed81edd7716d(template) {
    let node, key, hydrating = $fb40d00dea10da1a$var$isHydrating();
    if (!hydrating || !(node = (0, $1f5a16020b51a07b$export$2cb4986bed338027).registry.get(key = $fb40d00dea10da1a$export$a5a9dff0691837de()))) return template();
    if ((0, $1f5a16020b51a07b$export$2cb4986bed338027).completed) (0, $1f5a16020b51a07b$export$2cb4986bed338027).completed.add(node);
    (0, $1f5a16020b51a07b$export$2cb4986bed338027).registry.delete(key);
    return node;
}
function $fb40d00dea10da1a$export$c19731b2c49ee4c9(el, nodeName) {
    while(el && el.localName !== nodeName)el = el.nextSibling;
    return el;
}
function $fb40d00dea10da1a$export$5cf9b6f37b7c0802(start) {
    let end = start, count = 0, current = [];
    if ($fb40d00dea10da1a$var$isHydrating(start)) while(end){
        if (end.nodeType === 8) {
            const v = end.nodeValue;
            if (v === "$") count++;
            else if (v === "/") {
                if (count === 0) return [
                    end,
                    current
                ];
                count--;
            }
        }
        current.push(end);
        end = end.nextSibling;
    }
    return [
        end,
        current
    ];
}
function $fb40d00dea10da1a$export$6fef5763b6d3688d() {
    if ((0, $1f5a16020b51a07b$export$2cb4986bed338027).events && !(0, $1f5a16020b51a07b$export$2cb4986bed338027).events.queued) {
        queueMicrotask(()=>{
            const { completed: completed, events: events } = (0, $1f5a16020b51a07b$export$2cb4986bed338027);
            if (!events) return;
            events.queued = false;
            while(events.length){
                const [el, e] = events[0];
                if (!completed.has(el)) return;
                events.shift();
                $fb40d00dea10da1a$var$eventHandler(e);
            }
            if ((0, $1f5a16020b51a07b$export$2cb4986bed338027).done) {
                (0, $1f5a16020b51a07b$export$2cb4986bed338027).events = _$HY.events = null;
                (0, $1f5a16020b51a07b$export$2cb4986bed338027).completed = _$HY.completed = null;
            }
        });
        (0, $1f5a16020b51a07b$export$2cb4986bed338027).events.queued = true;
    }
}
function $fb40d00dea10da1a$var$isHydrating(node) {
    return !!(0, $1f5a16020b51a07b$export$2cb4986bed338027).context && !(0, $1f5a16020b51a07b$export$2cb4986bed338027).done && (!node || node.isConnected);
}
function $fb40d00dea10da1a$var$toPropertyName(name) {
    return name.toLowerCase().replace(/-([a-z])/g, (_, w)=>w.toUpperCase());
}
function $fb40d00dea10da1a$var$toggleClassKey(node, key, value) {
    const classNames = key.trim().split(/\s+/);
    for(let i = 0, nameLen = classNames.length; i < nameLen; i++)node.classList.toggle(classNames[i], value);
}
function $fb40d00dea10da1a$var$assignProp(node, prop, value, prev, isSVG, skipRef, props) {
    let isCE, isProp, isChildProp, propAlias, forceProp;
    if (prop === "style") return $fb40d00dea10da1a$export$1d567c320f4763bc(node, value, prev);
    if (prop === "classList") return $fb40d00dea10da1a$export$11c615ce16f87241(node, value, prev);
    if (value === prev) return prev;
    if (prop === "ref") {
        if (!skipRef) value(node);
    } else if (prop.slice(0, 3) === "on:") {
        const e = prop.slice(3);
        prev && node.removeEventListener(e, prev, typeof prev !== "function" && prev);
        value && node.addEventListener(e, value, typeof value !== "function" && value);
    } else if (prop.slice(0, 10) === "oncapture:") {
        const e = prop.slice(10);
        prev && node.removeEventListener(e, prev, true);
        value && node.addEventListener(e, value, true);
    } else if (prop.slice(0, 2) === "on") {
        const name = prop.slice(2).toLowerCase();
        const delegate = $fb40d00dea10da1a$export$389d7c657d123a81.has(name);
        if (!delegate && prev) {
            const h = Array.isArray(prev) ? prev[0] : prev;
            node.removeEventListener(name, h);
        }
        if (delegate || value) {
            $fb40d00dea10da1a$export$3f65cefe8380dbea(node, name, value, delegate);
            delegate && $fb40d00dea10da1a$export$ad0f7f87f67e17d6([
                name
            ]);
        }
    } else if (prop.slice(0, 5) === "attr:") $fb40d00dea10da1a$export$9fec4d97f1922e0b(node, prop.slice(5), value);
    else if (prop.slice(0, 5) === "bool:") $fb40d00dea10da1a$export$248913d9a30bef7a(node, prop.slice(5), value);
    else if ((forceProp = prop.slice(0, 5) === "prop:") || (isChildProp = $fb40d00dea10da1a$export$2c72a9edec54d5d9.has(prop)) || !isSVG && ((propAlias = $fb40d00dea10da1a$export$72dcdd3761a309a9(prop, node.tagName)) || (isProp = $fb40d00dea10da1a$export$8714badcfa4caafb.has(prop))) || (isCE = node.nodeName.includes("-") || "is" in props)) {
        if (forceProp) {
            prop = prop.slice(5);
            isProp = true;
        } else if ($fb40d00dea10da1a$var$isHydrating(node)) return value;
        if (prop === "class" || prop === "className") $fb40d00dea10da1a$export$2913c0c0b5623090(node, value);
        else if (isCE && !isProp && !isChildProp) node[$fb40d00dea10da1a$var$toPropertyName(prop)] = value;
        else node[propAlias || prop] = value;
    } else {
        const ns = isSVG && prop.indexOf(":") > -1 && $fb40d00dea10da1a$export$fa927d1d0495a67d[prop.split(":")[0]];
        if (ns) $fb40d00dea10da1a$export$75900142c9e21800(node, ns, prop, value);
        else $fb40d00dea10da1a$export$9fec4d97f1922e0b(node, $fb40d00dea10da1a$export$8915b7db7f70cfed[prop] || prop, value);
    }
    return value;
}
function $fb40d00dea10da1a$var$eventHandler(e) {
    if ((0, $1f5a16020b51a07b$export$2cb4986bed338027).registry && (0, $1f5a16020b51a07b$export$2cb4986bed338027).events) {
        if ((0, $1f5a16020b51a07b$export$2cb4986bed338027).events.find(([el, ev])=>ev === e)) return;
    }
    let node = e.target;
    const key = `$$${e.type}`;
    const oriTarget = e.target;
    const oriCurrentTarget = e.currentTarget;
    const retarget = (value)=>Object.defineProperty(e, "target", {
            configurable: true,
            value: value
        });
    const handleNode = ()=>{
        const handler = node[key];
        if (handler && !node.disabled) {
            const data = node[`${key}Data`];
            data !== undefined ? handler.call(node, data, e) : handler.call(node, e);
            if (e.cancelBubble) return;
        }
        node.host && typeof node.host !== "string" && !node.host._$host && node.contains(e.target) && retarget(node.host);
        return true;
    };
    const walkUpTree = ()=>{
        while(handleNode() && (node = node._$host || node.parentNode || node.host));
    };
    Object.defineProperty(e, "currentTarget", {
        configurable: true,
        get () {
            return node || document;
        }
    });
    if ((0, $1f5a16020b51a07b$export$2cb4986bed338027).registry && !(0, $1f5a16020b51a07b$export$2cb4986bed338027).done) (0, $1f5a16020b51a07b$export$2cb4986bed338027).done = _$HY.done = true;
    if (e.composedPath) {
        const path = e.composedPath();
        retarget(path[0]);
        for(let i = 0; i < path.length - 2; i++){
            node = path[i];
            if (!handleNode()) break;
            if (node._$host) {
                node = node._$host;
                walkUpTree();
                break;
            }
            if (node.parentNode === oriCurrentTarget) break;
        }
    } else walkUpTree();
    retarget(oriTarget);
}
function $fb40d00dea10da1a$var$insertExpression(parent, value, current, marker, unwrapArray) {
    const hydrating = $fb40d00dea10da1a$var$isHydrating(parent);
    if (hydrating) {
        !current && (current = [
            ...parent.childNodes
        ]);
        let cleaned = [];
        for(let i = 0; i < current.length; i++){
            const node = current[i];
            if (node.nodeType === 8 && node.data.slice(0, 2) === "!$") node.remove();
            else cleaned.push(node);
        }
        current = cleaned;
    }
    while(typeof current === "function")current = current();
    if (value === current) return current;
    const t = typeof value, multi = marker !== undefined;
    parent = multi && current[0] && current[0].parentNode || parent;
    if (t === "string" || t === "number") {
        if (hydrating) return current;
        if (t === "number") {
            value = value.toString();
            if (value === current) return current;
        }
        if (multi) {
            let node = current[0];
            if (node && node.nodeType === 3) node.data !== value && (node.data = value);
            else node = document.createTextNode(value);
            current = $fb40d00dea10da1a$var$cleanChildren(parent, current, marker, node);
        } else if (current !== "" && typeof current === "string") current = parent.firstChild.data = value;
        else current = parent.textContent = value;
    } else if (value == null || t === "boolean") {
        if (hydrating) return current;
        current = $fb40d00dea10da1a$var$cleanChildren(parent, current, marker);
    } else if (t === "function") {
        (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>{
            let v = value();
            while(typeof v === "function")v = v();
            current = $fb40d00dea10da1a$var$insertExpression(parent, v, current, marker);
        });
        return ()=>current;
    } else if (Array.isArray(value)) {
        const array = [];
        const currentArray = current && Array.isArray(current);
        if ($fb40d00dea10da1a$var$normalizeIncomingArray(array, value, current, unwrapArray)) {
            (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>current = $fb40d00dea10da1a$var$insertExpression(parent, array, current, marker, true));
            return ()=>current;
        }
        if (hydrating) {
            if (!array.length) return current;
            if (marker === undefined) return current = [
                ...parent.childNodes
            ];
            let node = array[0];
            if (node.parentNode !== parent) return current;
            const nodes = [
                node
            ];
            while((node = node.nextSibling) !== marker)nodes.push(node);
            return current = nodes;
        }
        if (array.length === 0) {
            current = $fb40d00dea10da1a$var$cleanChildren(parent, current, marker);
            if (multi) return current;
        } else if (currentArray) {
            if (current.length === 0) $fb40d00dea10da1a$var$appendNodes(parent, array, marker);
            else $fb40d00dea10da1a$var$reconcileArrays(parent, current, array);
        } else {
            current && $fb40d00dea10da1a$var$cleanChildren(parent);
            $fb40d00dea10da1a$var$appendNodes(parent, array);
        }
        current = array;
    } else if (value.nodeType) {
        if (hydrating && value.parentNode) return current = multi ? [
            value
        ] : value;
        if (Array.isArray(current)) {
            if (multi) return current = $fb40d00dea10da1a$var$cleanChildren(parent, current, marker, value);
            $fb40d00dea10da1a$var$cleanChildren(parent, current, null, value);
        } else if (current == null || current === "" || !parent.firstChild) parent.appendChild(value);
        else parent.replaceChild(value, parent.firstChild);
        current = value;
    }
    return current;
}
function $fb40d00dea10da1a$var$normalizeIncomingArray(normalized, array, current, unwrap) {
    let dynamic = false;
    for(let i = 0, len = array.length; i < len; i++){
        let item = array[i], prev = current && current[normalized.length], t;
        if (item == null || item === true || item === false) ;
        else if ((t = typeof item) === "object" && item.nodeType) normalized.push(item);
        else if (Array.isArray(item)) dynamic = $fb40d00dea10da1a$var$normalizeIncomingArray(normalized, item, prev) || dynamic;
        else if (t === "function") {
            if (unwrap) {
                while(typeof item === "function")item = item();
                dynamic = $fb40d00dea10da1a$var$normalizeIncomingArray(normalized, Array.isArray(item) ? item : [
                    item
                ], Array.isArray(prev) ? prev : [
                    prev
                ]) || dynamic;
            } else {
                normalized.push(item);
                dynamic = true;
            }
        } else {
            const value = String(item);
            if (prev && prev.nodeType === 3 && prev.data === value) normalized.push(prev);
            else normalized.push(document.createTextNode(value));
        }
    }
    return dynamic;
}
function $fb40d00dea10da1a$var$appendNodes(parent, array, marker = null) {
    for(let i = 0, len = array.length; i < len; i++)parent.insertBefore(array[i], marker);
}
function $fb40d00dea10da1a$var$cleanChildren(parent, current, marker, replacement) {
    if (marker === undefined) return parent.textContent = "";
    const node = replacement || document.createTextNode("");
    if (current.length) {
        let inserted = false;
        for(let i = current.length - 1; i >= 0; i--){
            const el = current[i];
            if (node !== el) {
                const isParent = el.parentNode === parent;
                if (!inserted && !i) isParent ? parent.replaceChild(node, el) : parent.insertBefore(node, marker);
                else isParent && el.remove();
            } else inserted = true;
        }
    } else parent.insertBefore(node, marker);
    return [
        node
    ];
}
function $fb40d00dea10da1a$var$gatherHydratable(element, root) {
    const templates = element.querySelectorAll(`*[data-hk]`);
    for(let i = 0; i < templates.length; i++){
        const node = templates[i];
        const key = node.getAttribute("data-hk");
        if ((!root || key.startsWith(root)) && !(0, $1f5a16020b51a07b$export$2cb4986bed338027).registry.has(key)) (0, $1f5a16020b51a07b$export$2cb4986bed338027).registry.set(key, node);
    }
}
function $fb40d00dea10da1a$export$a5a9dff0691837de() {
    return (0, $1f5a16020b51a07b$export$2cb4986bed338027).getNextContextId();
}
function $fb40d00dea10da1a$export$36143b7c9c07dd39(props) {
    return (0, $1f5a16020b51a07b$export$2cb4986bed338027).context ? undefined : props.children;
}
function $fb40d00dea10da1a$export$da8cca6e5dfa3577(props) {
    return props.children;
}
const $fb40d00dea10da1a$export$c8eca95e306f7116 = ()=>undefined;
const $fb40d00dea10da1a$export$5df49ba75ba1c1f9 = Symbol();
function $fb40d00dea10da1a$export$8bd3fff6c675ca8d(parent, content) {
    !(0, $1f5a16020b51a07b$export$2cb4986bed338027).context && (parent.innerHTML = content);
}
function $fb40d00dea10da1a$var$throwInBrowser(func) {
    const err = new Error(`${func.name} is not supported in the browser, returning undefined`);
    console.error(err);
}
function $fb40d00dea10da1a$export$80e7718417253a51(fn, options) {
    $fb40d00dea10da1a$var$throwInBrowser($fb40d00dea10da1a$export$80e7718417253a51);
}
function $fb40d00dea10da1a$export$f3aefc4196cd5f3e(fn, options) {
    $fb40d00dea10da1a$var$throwInBrowser($fb40d00dea10da1a$export$f3aefc4196cd5f3e);
}
function $fb40d00dea10da1a$export$97f86213fef5749d(fn, options) {
    $fb40d00dea10da1a$var$throwInBrowser($fb40d00dea10da1a$export$97f86213fef5749d);
}
function $fb40d00dea10da1a$export$ea2375f6c0c9ffdc(template, ...nodes) {}
function $fb40d00dea10da1a$export$1844beb7faeb4553(name, props, children, needsId) {}
function $fb40d00dea10da1a$export$e92e0c287593a882(value) {}
function $fb40d00dea10da1a$export$9e97f11b9d683d7a(value) {}
function $fb40d00dea10da1a$export$9ab8bdc1e27e51e1(key, value) {}
function $fb40d00dea10da1a$export$7e66a08c0b8ab2aa() {}
function $fb40d00dea10da1a$export$755e9f954b4fd36e(node) {}
function $fb40d00dea10da1a$export$4e7f196112fea3c5(html) {}
function $fb40d00dea10da1a$export$8c2b042ce8153017(props, isSVG, skipChildren) {}
const $fb40d00dea10da1a$export$6acf61af03e62db = false;
const $fb40d00dea10da1a$export$40edfb7eeb78c4e8 = false;
const $fb40d00dea10da1a$var$SVG_NAMESPACE = "http://www.w3.org/2000/svg";
function $fb40d00dea10da1a$var$createElement(tagName, isSVG = false, is) {
    return isSVG ? document.createElementNS($fb40d00dea10da1a$var$SVG_NAMESPACE, tagName) : document.createElement(tagName, {
        is: is
    });
}
const $fb40d00dea10da1a$export$fa8d919ba61d84db = (...args)=>{
    (0, $1f5a16020b51a07b$export$849801d35d2160c9)();
    return $fb40d00dea10da1a$var$hydrate$1(...args);
};
function $fb40d00dea10da1a$export$602eac185826482c(props) {
    const { useShadow: useShadow } = props, marker = document.createTextNode(""), mount = ()=>props.mount || document.body, owner = (0, $1f5a16020b51a07b$export$5f4ed0d56c2c0edf)();
    let content;
    let hydrating = !!(0, $1f5a16020b51a07b$export$2cb4986bed338027).context;
    (0, $1f5a16020b51a07b$export$7ea7134f704deda4)(()=>{
        if (hydrating) (0, $1f5a16020b51a07b$export$5f4ed0d56c2c0edf)().user = hydrating = false;
        content || (content = (0, $1f5a16020b51a07b$export$c14f3e3abbc7d6b5)(owner, ()=>(0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>props.children)));
        const el = mount();
        if (el instanceof HTMLHeadElement) {
            const [clean, setClean] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(false);
            const cleanup = ()=>setClean(true);
            (0, $1f5a16020b51a07b$export$882461b6382ed46c)((dispose)=>$fb40d00dea10da1a$export$21a5ca8aa77d35ff(el, ()=>!clean() ? content() : dispose(), null));
            (0, $1f5a16020b51a07b$export$b36e5eaa3e8c43ab)(cleanup);
        } else {
            const container = $fb40d00dea10da1a$var$createElement(props.isSVG ? "g" : "div", props.isSVG), renderRoot = useShadow && container.attachShadow ? container.attachShadow({
                mode: "open"
            }) : container;
            Object.defineProperty(container, "_$host", {
                get () {
                    return marker.parentNode;
                },
                configurable: true
            });
            $fb40d00dea10da1a$export$21a5ca8aa77d35ff(renderRoot, content);
            el.appendChild(container);
            props.ref && props.ref(container);
            (0, $1f5a16020b51a07b$export$b36e5eaa3e8c43ab)(()=>el.removeChild(container));
        }
    }, undefined, {
        render: !hydrating
    });
    return marker;
}
function $fb40d00dea10da1a$export$9a3ff77bac07eb26(component, props) {
    const cached = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(component);
    return (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>{
        const component = cached();
        switch(typeof component){
            case "function":
                return (0, $1f5a16020b51a07b$export$363ebc4b78b8f807)(()=>component(props));
            case "string":
                const isSvg = $fb40d00dea10da1a$export$ccaf9b9a82de4b98.has(component);
                const el = (0, $1f5a16020b51a07b$export$2cb4986bed338027).context ? $fb40d00dea10da1a$export$4109ed81edd7716d() : $fb40d00dea10da1a$var$createElement(component, isSvg, (0, $1f5a16020b51a07b$export$363ebc4b78b8f807)(()=>props.is));
                $fb40d00dea10da1a$export$3ae0fd4797ed47c8(el, props, isSvg);
                return el;
        }
    });
}
function $fb40d00dea10da1a$export$e18282e419e46834(props) {
    const [, others] = (0, $1f5a16020b51a07b$export$45029c61b0073d87)(props, [
        "component"
    ]);
    return $fb40d00dea10da1a$export$9a3ff77bac07eb26(()=>props.component, others);
}






var $3646fb1bd6f1505b$exports = {};
$3646fb1bd6f1505b$exports = JSON.parse("[{\"title\":\"JS Art - Studio\",\"url\":\"https://joshhoegen.com/studio/\",\"icon\":\"star\",\"description\":\"Build your own interactive video art\",\"order\":10},{\"title\":\"JS Art - Pixels\",\"url\":\"https://joshhoegen.com/trails/\",\"icon\":\"star\",\"images\":[\"img/kaleidoscope.png\"],\"template\":\"live.html\",\"modules\":[\"kaleidescope\"],\"description\":\"Interactive video art\",\"order\":9},{\"title\":\"JS Art - Kaleidoscope\",\"url\":\"https://joshhoegen.com/kaleidoscope/\",\"icon\":\"star\",\"images\":[\"img/kaleidoscope.png\"],\"template\":\"soundcloud\",\"description\":\"Interactive video art\",\"order\":8},{\"title\":\"JS Art - Portal\",\"url\":\"https://joshhoegen.com/portal/\",\"icon\":\"star\",\"images\":[\"img/portal.png\"],\"template\":\"live.html\",\"modules\":[\"portal\"],\"description\":\"Interactive video art\",\"order\":7},{\"title\":\"JS Art - Fractals\",\"url\":\"https://joshhoegen.com/fractals/\",\"icon\":\"star\",\"images\":[\"img/kaleidoscope.png\"],\"template\":\"soundcloud\",\"description\":\"Interactive video art\",\"order\":6},{\"title\":\"Flickr | Art\",\"url\":\"http://flickr.com/photos/joshhoegen\",\"icon\":\"flickr\",\"images\":[\"img/flickr.png\"],\"modules\":[\"kaleidescope\"],\"description\":\"Visual Art\",\"order\":3},{\"title\":\"Instagram | Art\",\"url\":\"http://instagram.com/joshhoegen\",\"icon\":\"instagram\",\"images\":[\"img/instagram.png\"],\"modules\":[\"kaleidescope\"],\"description\":\"Art and life in static images\",\"order\":2},{\"title\":\"Git | Code\",\"url\":\"http://github.com/joshhoegen\",\"icon\":\"github\",\"images\":[\"img/github.png\"],\"description\":\"Sauce\",\"order\":1},{\"title\":\"Sound Cloud | Music\",\"url\":\"http://soundcloud.com/byutifu\",\"icon\":\"soundcloud\",\"images\":[\"img/soundcloud.png\"],\"description\":\"Remix of Jazz and other Retro Artists\",\"order\":4},{\"title\":\"LinkedIn | Pro Profile\",\"url\":\"http://linkedin.com/pub/josh-hoegen/b/a9/9b8\",\"icon\":\"linkedin\",\"images\":[\"img/linkedin.png\"],\"description\":\"Professional profile\",\"order\":5}]");


var $2ccd037441e7bfdb$var$_tmpl$ = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<li class=pages-listing><a target=_blank rel="noopener noreferrer"><i></i><span>- `);
const $2ccd037441e7bfdb$var$PagesTemplate = ()=>{
    const d = (0, (/*@__PURE__*/$parcel$interopDefault($3646fb1bd6f1505b$exports))).sort((a, b)=>a.order.toString().localeCompare(b.order));
    return Object.keys(d).map((key)=>(0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)($2ccd037441e7bfdb$var$PagesHTML, (0, $1f5a16020b51a07b$export$9d1611c77c2fe928)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($3646fb1bd6f1505b$exports)))[key])));
};
const $2ccd037441e7bfdb$var$PagesHTML = (props)=>{
    return (()=>{
        var _el$ = $2ccd037441e7bfdb$var$_tmpl$(), _el$2 = _el$.firstChild, _el$3 = _el$2.firstChild, _el$4 = _el$3.nextSibling, _el$5 = _el$4.firstChild;
        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$2, ()=>props.title, _el$4);
        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$4, ()=>props.description, null);
        (0, $1f5a16020b51a07b$export$314dade334ae905d)((_p$)=>{
            var _v$ = props.url, _v$2 = `fa fa-${props.icon}`;
            _v$ !== _p$.e && (0, $fb40d00dea10da1a$export$9fec4d97f1922e0b)(_el$2, "href", _p$.e = _v$);
            _v$2 !== _p$.t && (_el$3.className = _p$.t = _v$2);
            return _p$;
        }, {
            e: undefined,
            t: undefined
        });
        return _el$;
    })();
};
var $2ccd037441e7bfdb$export$2e2bcd8739ae039 = $2ccd037441e7bfdb$var$PagesTemplate;


var $f987a06f5e0b667c$var$_tmpl$ = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div id=jh-header><button class=menu-button><a class=menu-icon>\u{2630}</a></button><div id=jh-nav><ul></ul></div><img class=logo alt><h1>Josh Hoegen &raquo; &#9835; &hearts;`), $f987a06f5e0b667c$var$_tmpl$2 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=drawer>`);
var $4524e922262c2dd1$exports = {};
$4524e922262c2dd1$exports = $parcel$resolve("5zyUS");


const $f987a06f5e0b667c$var$logo = new URL($4524e922262c2dd1$exports).toString();
const $f987a06f5e0b667c$var$HeaderTemplate = ()=>{
    const [menuToggle, setMenuToggle] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(false);
    const menuHandler = (data)=>{
        setMenuToggle(!data);
    };
    return [
        (()=>{
            var _el$ = $f987a06f5e0b667c$var$_tmpl$(), _el$2 = _el$.firstChild, _el$3 = _el$2.nextSibling, _el$4 = _el$3.firstChild, _el$5 = _el$3.nextSibling;
            _el$2.$$click = ()=>menuHandler(menuToggle());
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$4, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $2ccd037441e7bfdb$export$2e2bcd8739ae039), {}));
            (0, $fb40d00dea10da1a$export$9fec4d97f1922e0b)(_el$5, "src", $f987a06f5e0b667c$var$logo);
            (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>(0, $fb40d00dea10da1a$export$2913c0c0b5623090)(_el$4, `pages${menuToggle() ? ' show' : ''}`));
            return _el$;
        })(),
        $f987a06f5e0b667c$var$_tmpl$2()
    ];
};
var $f987a06f5e0b667c$export$2e2bcd8739ae039 = $f987a06f5e0b667c$var$HeaderTemplate;
(0, $fb40d00dea10da1a$export$ad0f7f87f67e17d6)([
    "click"
]);




var $123849a2341b426c$exports = {};
$123849a2341b426c$exports = JSON.parse("{\"kaleidoscope\":{\"href\":\"/pages/kaleidoscope/\",\"description\":\"More video and audio to create situational and psychedelic video art in your browser!\",\"title\":\"Crunk Kaleidoscope\"},\"fractals\":{\"href\":\"/pages/fractals/\",\"description\":\"Use video and audio to create unique and psychedelic video art (GPU heavy; use a performant phone/computer)!\",\"title\":\"Psychedelic Video Fractals\",\"video\":null},\"portal\":{\"href\":\"/pages/portal/\",\"description\":\"Don't get dizzy! Works best in the dark... or anywhere?\",\"title\":\"Portal\"},\"light-trails\":{\"href\":\"/pages/trails/\",\"description\":\"Create pixels or swirls from the color you choose. A nice ambient piece.\",\"title\":\"Pixel Trails\"}}");


var $4e63e146345fa271$var$_tmpl$ = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<img width=100%>`), $4e63e146345fa271$var$_tmpl$2 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=feature-child><a class=black-and-white><div class=title></div></a><div class=description>`), $4e63e146345fa271$var$_tmpl$3 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<h1 class=feature-h1>Interactive Art`), $4e63e146345fa271$var$_tmpl$4 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=feature>`), $4e63e146345fa271$var$_tmpl$5 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=long-text><p>In 1999, I would have told ya computers were destroying art... music... all the things I love to create. While draining my soul in the designosphere, I saw my code-monkey co-workers making money and having fun making it. so, I learned to code... As an artist, I knew it was my responsibility to start creating with this newfound medium. Since taking on this responsibility, we've propelled into a Brave New World that can render the universe digitally in 3D & AI-prompted generative art; so here I sit inbetween worlds... Trying to leverage Javascript's interactivity, while aiming to offer some eye & ear candy.</p><p>Want to mix the effects yourself? Open the <a href=/studio/>Video Art Studio</a> and build your own experience.</p><p>- Josh`);
// import kaleidoscopeVideo from './media/kaleidoscope.gif'
// import kaleidoscopeImage from './media/kaleidoscope.png'
// import lightTrailsVideo from './media/light-trails.gif'
// import lightTrailsImage from './media/light-trails.png'
// import fractalsVideo from './media/fractals.gif'
// import fractalsImage from './media/fractals.png'
// import portalVideo from './media/portal.gif'
// import portalImage from './media/portal.png'
const $4e63e146345fa271$var$interactiveArtKeys = Object.keys((0, (/*@__PURE__*/$parcel$interopDefault($123849a2341b426c$exports))));
const $4e63e146345fa271$var$isLunaDev = false;
const $4e63e146345fa271$var$withProjectionMask = (href)=>{
    if (!$4e63e146345fa271$var$isLunaDev) return href;
    const url = new URL(href, window.location.origin);
    url.searchParams.set('projectionMask', 'true');
    return `${url.pathname}${url.search}${url.hash}`;
};
var $6eb56018d0a942a1$exports = {};
$6eb56018d0a942a1$exports = $parcel$resolve("9As52");


var $a90e744477a0719e$exports = {};
$a90e744477a0719e$exports = $parcel$resolve("kZUOe");


var $76464c4ce25e4349$exports = {};
$76464c4ce25e4349$exports = $parcel$resolve("1wMBv");


var $284c68727c2df46c$exports = {};
$284c68727c2df46c$exports = $parcel$resolve("h8WUw");


// TODO: I know, I know. So much to do; so little time
const $4e63e146345fa271$var$videos = {
    kaleidoscope: new URL($6eb56018d0a942a1$exports).toString(),
    'light-trails': new URL($a90e744477a0719e$exports).toString(),
    portal: new URL($76464c4ce25e4349$exports).toString(),
    fractals: new URL($284c68727c2df46c$exports).toString()
};
var $62ad0f399059fe2d$exports = {};
$62ad0f399059fe2d$exports = $parcel$resolve("aGvM3");


var $fb0b13c0537607b8$exports = {};
$fb0b13c0537607b8$exports = $parcel$resolve("kA7Jf");


var $06c663de8df6dc43$exports = {};
$06c663de8df6dc43$exports = $parcel$resolve("h7Btu");


var $7dc3002e4286f0a3$exports = {};
$7dc3002e4286f0a3$exports = $parcel$resolve("60pqL");


// const images = {
//   kaleidoscope: kaleidoscopeImage,
//   'light-trails': lightTrailsImage,
//   portal: portalImage,
//   fractals: fractalsImage,
// }
const $4e63e146345fa271$var$images = {
    kaleidoscope: new URL($62ad0f399059fe2d$exports).toString(),
    'light-trails': new URL($fb0b13c0537607b8$exports).toString(),
    portal: new URL($06c663de8df6dc43$exports).toString(),
    fractals: new URL($7dc3002e4286f0a3$exports).toString()
};
const $4e63e146345fa271$var$ImageEl = (props)=>{
    const [src, setSrc] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(props.img);
    const mouseOverHandler = ()=>{
        setSrc(props.video);
    };
    const mouseOutHandler = ()=>{
        setSrc(props.img);
    };
    return (()=>{
        var _el$ = $4e63e146345fa271$var$_tmpl$();
        _el$.$$click = mouseOutHandler;
        _el$.$$mouseout = mouseOutHandler;
        _el$.$$mouseover = mouseOverHandler;
        (0, $1f5a16020b51a07b$export$314dade334ae905d)((_p$)=>{
            var _v$ = src(), _v$2 = props.id;
            _v$ !== _p$.e && (0, $fb40d00dea10da1a$export$9fec4d97f1922e0b)(_el$, "src", _p$.e = _v$);
            _v$2 !== _p$.t && (0, $fb40d00dea10da1a$export$9fec4d97f1922e0b)(_el$, "id", _p$.t = _v$2);
            return _p$;
        }, {
            e: undefined,
            t: undefined
        });
        return _el$;
    })();
};
const $4e63e146345fa271$var$InteractiveArt = ()=>{
    const projectLinks = [];
    for (const key of $4e63e146345fa271$var$interactiveArtKeys){
        console.log(key);
        const feature = (0, (/*@__PURE__*/$parcel$interopDefault($123849a2341b426c$exports)))[key];
        projectLinks.push((()=>{
            var _el$2 = $4e63e146345fa271$var$_tmpl$2(), _el$3 = _el$2.firstChild, _el$4 = _el$3.firstChild, _el$5 = _el$3.nextSibling;
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$3, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)($4e63e146345fa271$var$ImageEl, {
                id: `video-${key}`,
                get img () {
                    return $4e63e146345fa271$var$images[key];
                },
                get video () {
                    return $4e63e146345fa271$var$videos[key];
                },
                width: "100%"
            }), _el$4);
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$4, ()=>feature.title);
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$5, ()=>feature.description);
            (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>(0, $fb40d00dea10da1a$export$9fec4d97f1922e0b)(_el$3, "href", $4e63e146345fa271$var$withProjectionMask(feature.href)));
            return _el$2;
        })());
    }
    return [
        $4e63e146345fa271$var$_tmpl$3(),
        (()=>{
            var _el$7 = $4e63e146345fa271$var$_tmpl$4();
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$7, projectLinks);
            return _el$7;
        })(),
        $4e63e146345fa271$var$_tmpl$5()
    ];
};
var $4e63e146345fa271$export$2e2bcd8739ae039 = $4e63e146345fa271$var$InteractiveArt;
(0, $fb40d00dea10da1a$export$ad0f7f87f67e17d6)([
    "mouseover",
    "mouseout",
    "click"
]);


var $939440df874892e4$var$_tmpl$ = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div id=jh-page>`);
const $939440df874892e4$var$App = ()=>{
    return [
        (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $f987a06f5e0b667c$export$2e2bcd8739ae039), {}),
        (()=>{
            var _el$ = $939440df874892e4$var$_tmpl$();
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $4e63e146345fa271$export$2e2bcd8739ae039), {}));
            return _el$;
        })()
    ];
};
(0, $fb40d00dea10da1a$export$b3890eb0ae9dca99)(()=>(0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)($939440df874892e4$var$App, {}), document.getElementById('content'));


//# sourceMappingURL=Lazy-Portfolio.adfe4bcf.js.map
